const default_pregnancy_milestone_value = [
  {
    id: 1,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Hamileliğin 1. haftasında, vücudunuz geçen ay döllenmemiş yumurtayı atan rahim zarını döktüğü için vajinal kanamanız olacaktır.",
            value: false,
          },
          {
            text: "Şişkinlik ve dalgalanan hormonlardan kaynaklanan ruh hali değişiklikleri de dahil olmak üzere regl döneminize başlarken normalde hissettiğiniz tipik semptomları yaşayacaksınız.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Beslenme ve Sağlık",
        checklists: [
          {
            text: "Hergün daha fazla taze meyve, sebze ve 3-4 litre su tüketin.",
            value: false,
          },
          {
            text: "Her gün 400 mikrogram folik asit almaya başlamalısınız.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Genel Sağlık Kontrolleri",
        checklists: [
          {
            text: "Son iki adet döneminizin tarihini yazın.",
            value: false,
          },
          {
            text: "Aldığınız herhangi bir ilacın yan etkileri hakkında daha fazla bilgi edinmek, tıbbi geçmişinizi ve aşı geçmişinizi gözden geçirmek ve sizi cinsel yolla bulaşan enfeksiyonlara karşı taramak için bir ön gebelik kontrolü yaptırın.",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek ve hamilelik sırasında komplikasyonları önlemek için diş hekimini ziyaret edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Hatırlatmalar",
        checklists: [
          {
            text: "Yeterli miktarda uyuyun.",
            value: false,
          },
          {
            text: "Bebeğinizin gebelik süresini hesaplamak için ihtiyacınız olacağından adetinizin ilk gününü kaydedin.",
            value: false,
          },
          {
            text: "Siz ve eşiniz için sağlıklı, stressiz bir yaşam tarzı zamanı.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Bu hafta yumurtlayacaksınız. Servikal mukusunuz artar ve yumurtlama zamanında daha ince, yapışkan ve kaygandır. Mukus berrak beyaz bir jele benzer.",
            value: false,
          },
          {
            text: "Bazal vücut sıcaklığınızı takip ediyorsanız, yükseldiğini fark edeceksiniz. Yumurtlamadan önce en düşük seviyededir, daha sonra yumurtlama meydana gelir gelmez yaklaşık yarım derece kadar yükselir.",
            value: false,
          },
          {
            text: "Hafif lekelenme, karnınızın alt kısmında kramplar ve artan cinsel dürtü gibi başka yumurtlama belirtileri yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Beslenme ve Sağlık",
        checklists: [
          {
            text: "Her gün daha fazla taze meyve ve sebze tüketin; diyetinize yağsız et ve balık ekleyin.",
            value: false,
          },
          {
            text: "Doğum uzmanınız tarafından önerilen iyi bir doğum öncesi takviyesi alın -folik asit içermelidir.",
            value: false,
          },
          {
            text: "Her gün en az 10 bardak su için.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının; kafein alımınızı azaltın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Genel Sağlık Kontrolleri",
        checklists: [
          {
            text: "Henüz yapmadıysanız diş hekiminizi ziyaret edin.",
            value: false,
          },
          {
            text: "İster reçeteli ister reçetesiz olsun, kullandığınız herhangi bir ilaç hakkında doktorunuzla konuşun ve bunlara devam etmenin güvenli olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Hatırlatmalar",
        checklists: [
          {
            text: "Günlük en az 8 saat uyku ve düzenli egzersizle stressiz bir yaşam tarzı sürdürün.",
            value: false,
          },
          {
            text: "Adet döngünüzü takip edin ve yumurtlama belirtileri arayın.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "1-2 gün süren bazı implantasyon kanamaları veya lekelenmeleri fark edebilirsiniz.",
            value: false,
          },
          {
            text: "Koku duyunuz artabilir.",
            value: false,
          },
          {
            text: "Bazal vücut ısınız her zaman yüksek olabilir ve alışılmadık şekilde yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Evde hamilelik testiniz henüz pozitif bir sonuç gösterebilir veya göstermeyebilir, çünkü hamileliğin yansıması için çok erken olabilir.",
            value: false,
          },
          {
            text: "Mide bulantısı, şişkinlik veya acil idrara çıkma ihtiyacı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Göğüsleriniz normalden daha hassas olabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Çiğ yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Folik asit içeren doğum öncesi takviyenin günlük alımına başlayın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Daha az kafein tüketin.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Sağlık kontrolleri",
        checklists: [
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin.",
            value: false,
          },
          {
            text: "Evde hamilelik testi seti satın alın.",
            value: false,
          },
          {
            text: "İyi bir kadın doğum uzmanı bulun.",
            value: false,
          },
          {
            text: "İster reçeteli ister reçetesiz olsun, kullandığınız herhangi bir ilacı doktorunuza söyleyin ve bunlara devam etmenin güvenli olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Hatırlatmalar",
        checklists: [
          {
            text: "Hayatınızdaki stresi en aza indirin.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Düzenli egzersiz yapın.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 4,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "1-2 gün süren bazı implantasyon kanamaları veya lekelenmeleri fark edebilirsiniz.",
            value: false,
          },
          {
            text: "Koku duyunuz artabilir.",
            value: false,
          },
          {
            text: "Bazal vücut ısınız her zaman yüksek olabilir ve alışılmadık şekilde yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Evde yapılan hamilelik testiniz henüz pozitif bir sonuç gösterebilir veya göstermeyebilir, çünkü hamileliğin yansıması için çok erken olabilir.",
            value: false,
          },
          {
            text: "Mide bulantısı, şişkinlik veya acil idrara çıkma ihtiyacı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Göğüsleriniz normalden daha hassas olabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Her gün folik asit içeren iyi bir doğum öncesi takviyesi alın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Daha az kafein tüketin ya da hiç tüketmeyin.",
            value: false,
          },
          {
            text: "Çiğ yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Koruyucu içeren yiyecekleri tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Şeker ve tuz alımınızı azaltın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Gebelikte Sağlık Kontrolleri",
        checklists: [
          {
            text: "Hamileliğinizi doğrulamak için evde hamilelik testi yapın.",
            value: false,
          },
          {
            text: "Bir kadın hastalıkları ve doğum uzmanı bulun ve ilk doğum öncesi randevunuzu alın.",
            value: false,
          },
          {
            text: "Doktorunuza, reçeteli veya reçetesiz kullandığınız ilaçları söyleyin ve onlarla devam etmenin güvenli olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Kendinizde veya eşinizde Cinsel Yolla Bulaşan Enfeksiyon (STI) olabileceğini düşünüyorsanız, mümkün olduğunca erken bir kontrole gidin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Hayatınızdaki stresi en aza indirin.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Düzenli egzersiz yapın.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Belirtileri",
        checklists: [
          {
            text: "Koku duyunuz artabilir.",
            value: false,
          },
          {
            text: "Bazal vücut ısınız her zaman yüksek olabilir ve alışılmadık şekilde yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Evde yapılan hamilelik testiniz henüz pozitif bir sonuç gösterebilir veya göstermeyebilir, çünkü hamileliğin yansıması için çok erken olabilir.",
            value: false,
          },
          {
            text: "Mide bulantısı, şişkinlik veya idrar yapmak için acil bir ihtiyaç duyabilirsiniz.",
            value: false,
          },
          {
            text: "Göğüsleriniz normalden daha büyük ve daha hassas hissedebilir.",
            value: false,
          },
          {
            text: "Ani ruh hali değişimleri, hafif mide krampları yaşayabilir ve adetinizin geciktiğini fark edebilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Her gün folik asit içeren iyi bir doğum öncesi takviyesi alın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Daha az kafein tüketin.",
            value: false,
          },
          {
            text: "Çiğ yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Koruyucu içeren yiyecekleri tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Şeker ve tuz alımınızı azaltın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Süreniz gecikirse, sabah ilk idrarını örnek olarak kullanarak hamile olup olmadığınızı kontrol etmek için evde hamilelik testi kullanın.",
            value: false,
          },
          {
            text: "Hamilelik testiniz pozitifse, hamileliğinizi doğrulamak için bir kadın doğum uzmanından randevu alın.",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzun Bilmesi Gerekenler",
        checklists: [
          {
            text: "Adet takviminiz ve son adet döneminizin tarihi",
            value: false,
          },
          {
            text: "Aile planlaması aracı ve daha önce kullanılan kontraseptif türleri",
            value: false,
          },
          {
            text: "Daha önce genital bir enfeksiyon geçirdiyseniz",
            value: false,
          },
          {
            text: "Herhangi bir anormal pap smear geçirdiyseniz",
            value: false,
          },
          {
            text: "Üreme organınızla ilgili herhangi bir sorun, hastalık veya ameliyat geçirdiyseniz",
            value: false,
          },
          {
            text: "Önceki kürtaj, düşük veya doğumla ilgili bilgiler",
            value: false,
          },
          {
            text: "Daha önce dış gebelik veya molar gebelik geçirdiyseniz",
            value: false,
          },
          {
            text: "Şu anda herhangi bir tıbbi durumunuz varsa - büyük veya küçük",
            value: false,
          },
          {
            text: "Ailenizin hastalık öyküsü veya kalıtsal sorunlar",
            value: false,
          },
          {
            text: "Daha önce kan nakli yaptırdıysanız",
            value: false,
          },
          {
            text: "Suçiçeği geçirdiyseniz veya suçiçeği ve difteri aşısı olduysanız",
            value: false,
          },
          {
            text: "İlaç kullanıyorsanız",
            value: false,
          },
          {
            text: "Siz ve eşinizin kan grupları ve Rh faktörü",
            value: false,
          },
          {
            text: "MMR aşısı olduysanız",
            value: false,
          },
          {
            text: "HPV aşısı yaptırdıysanız",
            value: false,
          },
          {
            text: "Aşı geçmişiniz",
            value: false,
          },
          {
            text: "Ruh sağlığı geçmişiniz: herhangi bir depresyon geçmişi, anksiyete bozukluğu veya diğer akıl sağlığı bozuklukları",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Hayatınızdaki stresi en aza indirin.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Düzenli egzersiz yapın.",
            value: false,
          },
          {
            text: "Kimyasallar ve zararlı bileşenler içeren güzellik bakımlarından kaçının.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 6,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Göğüsleriniz hassas ve şişmiş hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Her zamankinden daha yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Kokulara karşı hassas olacaksınız.",
            value: false,
          },
          {
            text: "Bazal vücut ısınız dinlenirken bile her zaman yüksek olabilir.",
            value: false,
          },
          {
            text: "Mide bulantısı veya şişkinlik yaşamaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Daha sık idrara çıkma ihtiyacı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Ruh hali değişimleri yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Hafif mide krampları yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Adetiniz gecikir.",
            value: false,
          },
          {
            text: "Evde yapılan bir hamilelik testi muhtemelen olumlu bir sonuç gösterecektir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Koruyucu içeren yiyecekleri tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Şeker ve tuz alımınızı azaltın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Süreniz geciktiyse, hamile olup olmadığınızı kontrol etmek için evde hamilelik testi kullanın.",
            value: false,
          },
          {
            text: "Hamilelik testiniz pozitifse, hamileliğinizi doğrulamak için bir doğum uzmanından randevu alın.",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzun Bilmesi Gerekenler",
        checklists: [
          {
            text: "Adet takviminiz ve son adet döneminizin tarihi",
            value: false,
          },
          {
            text: "Aile planlaması aracı ve daha önce kullanılan doğum kontrol hapı türleri",
            value: false,
          },
          {
            text: "Daha önce genital bir enfeksiyon geçirdiyseniz",
            value: false,
          },
          {
            text: "Hiç anormal bir pap smear geçirdiyseniz",
            value: false,
          },
          {
            text: "Üreme organlarıyla ilgili herhangi bir sorun, hastalık veya ameliyat geçirdiyseniz",
            value: false,
          },
          {
            text: "Daha önce doğurganlık tedavisi aldıysanız",
            value: false,
          },
          {
            text: "Önceki kürtaj, düşük veya doğumla ilgili bilgiler",
            value: false,
          },
          {
            text: "Daha önce dış gebelik veya molar gebelik geçirdiyseniz",
            value: false,
          },
          {
            text: "Diyabet, hipertansiyon, epilepsi, kalp problemleri, tiroid bozuklukları, otoimmün bozukluklar veya herhangi bir ciddi hastalığınız varsa",
            value: false,
          },
          {
            text: "Hazımsızlık çekiyorsanız",
            value: false,
          },
          {
            text: "Kan nakli geçirdiyseniz",
            value: false,
          },
          {
            text: "İlaç kullanıyorsanız",
            value: false,
          },
          {
            text: "Ailenizde kanser, diyabet, keloidler veya diğer kalıtsal hastalıklar gibi hastalık öyküsü",
            value: false,
          },
          {
            text: "Suçiçeği geçirdiyseniz veya suçiçeği ve difteri aşısı olduysanız",
            value: false,
          },
          {
            text: "HPV aşısı olduysanız",
            value: false,
          },
          {
            text: "Aşı geçmişiniz",
            value: false,
          },
          {
            text: "Belirli ilaçlara, maddelere veya yiyeceklere alerjiniz varsa",
            value: false,
          },
          {
            text: "Daha önce anesteziyle ilgili sorun yaşadıysanız",
            value: false,
          },
          {
            text: "Ruh sağlığı geçmişiniz: Herhangi bir depresyon geçmişi, anksiyete bozukluğu veya diğer akıl sağlığı bozuklukları",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Hayatınızdaki stresi en aza indirin.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Sağlıklı bir yaşam tarzı yönetin.",
            value: false,
          },
          {
            text: "Düzenli egzersiz yapın.",
            value: false,
          },
          {
            text: "Sert kimyasallarla güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Diyetinizi değiştirerek mide bulantısını gidermeye çalışın (Küçük porsiyonlar yemeyi deneyin; zencefil ve kuru krakerler de bulantıyı hafifletmeye yardımcı olur).",
            value: false,
          },
          {
            text: "Düzenli egzersiz yapıyorsanız, doğum uzmanınızla buna devam edip edemeyeceğinizi konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "Lekelenme yaşarsanız (Hamileliğin erken dönemlerinde ortaya çıkabilmesine rağmen, lekelenme ayrıca erken düşük veya ektopik gebelik belirtisi olabilir.)",
            value: false,
          },
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı veya yanma hissi yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 7,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Adetiniz gecikti.",
            value: false,
          },
          {
            text: "Göğüsleriniz hassas ve şişmiş hissediyor.",
            value: false,
          },
          {
            text: "Her zamankinden daha yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Koku duyunuz artabilir.",
            value: false,
          },
          {
            text: "Bazal vücut ısınız dinlenirken bile her zaman yüksek olabilir.",
            value: false,
          },
          {
            text: "Mide bulantısı veya şişkinlik yaşamaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Daha sık idrara çıkma ihtiyacı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Cildinizde değişiklikler yaşayabilirsiniz (yani cildiniz daha kuru veya daha yağlı hale gelebilir).",
            value: false,
          },
          {
            text: "Ruh hali değişimleri yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Hafif mide krampları yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Yiyecek istekleri ve / veya yiyecek isteksizlikleri yaşamaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Evde yapılan bir hamilelik testi muhtemelen olumlu bir sonuç gösterecektir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyni ve omuriliği için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Koruyucu içeren yiyecekleri tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Şeker ve tuz alımınızı azaltın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "İlk doğum öncesi kontrol randevusu (7. hafta ile 8. hafta arasında, isterseniz daha önce de olabilir!)",
            value: false,
          },
          {
            text: "Canlılık ultrasonu - gebeliğin normal şekilde ilerlediğini doğrulamak için",
            value: false,
          },
          {
            text: "Kan testleri (İlk trimesterde herhangi bir zamanda) - tam kan sayımı, kan grubu, hepatit, cinsel yolla bulaşan hastalıklar (HIV, Sifiliz) ve kızamıkçık, suçiçeği bağışıklığını kontrol etmek için",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzun Bilmesi Gerekenler",
        checklists: [
          {
            text: "Adet takviminiz ve son adet döneminizin tarihi",
            value: false,
          },
          {
            text: "Aile planlaması aracı ve daha önce kullanılan doğum kontrol hapı türleri",
            value: false,
          },
          {
            text: "Daha önce genital bir enfeksiyon geçirdiyseniz",
            value: false,
          },
          {
            text: "Herhangi bir anormal pap smear geçirdiyseniz",
            value: false,
          },
          {
            text: "Üreme organlarıyla ilgili herhangi bir sorun, hastalık veya ameliyat geçirdiyseniz",
            value: false,
          },
          {
            text: "Herhangi bir doğurganlık tedavisi aldıysanız",
            value: false,
          },
          {
            text: "Önceki kürtaj, düşük veya doğumla ilgili bilgiler",
            value: false,
          },
          {
            text: "Daha önce dış gebelik veya molar gebelik geçirdiyseniz",
            value: false,
          },
          {
            text: "Diyabet, hipertansiyon, epilepsi, kalp problemleri, tiroid bozuklukları, otoimmün bozukluklar veya herhangi bir ciddi hastalığınız varsa",
            value: false,
          },
          {
            text: "Hazımsızlık çekiyorsanız",
            value: false,
          },
          {
            text: "Kan nakli geçirdiyseniz",
            value: false,
          },
          {
            text: "İlaç kullanıyorsanız",
            value: false,
          },
          {
            text: "Ailenizde kanser, diyabet, keloidler veya diğer kalıtsal hastalıklar gibi hastalık öyküsü",
            value: false,
          },
          {
            text: "Daha önce suçiçeği geçirdiyseniz veya suçiçeği aşısı olduysanız",
            value: false,
          },
          {
            text: "Aşı geçmişiniz",
            value: false,
          },
          {
            text: "HPV aşısı olduysanız",
            value: false,
          },
          {
            text: "Belirli ilaçlara, maddelere veya yiyeceklere alerjiniz varsa",
            value: false,
          },
          {
            text: "Daha önce anesteziyle ilgili sorun yaşadıysanız",
            value: false,
          },
          {
            text: "Ruh sağlığı geçmişiniz: herhangi bir depresyon geçmişi, anksiyete bozukluğu veya diğer akıl sağlığı bozuklukları",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Hayatınızdaki stresi en aza indirin.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Sağlıklı bir yaşam tarzı yönetin.",
            value: false,
          },
          {
            text: "Düzenli egzersiz yapın.",
            value: false,
          },
          {
            text: "Sert kimyasallarla güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Diyetinizi değiştirerek mide bulantısını gidermeye çalışın (Küçük porsiyonlar yemeyi deneyin; zencefil ve kuru krakerler de bulantıyı hafifletmeye yardımcı olur).",
            value: false,
          },
          {
            text: "Düzenli egzersiz yapıyorsanız, doğum uzmanınızla buna devam edip edemeyeceğinizi konuşun.",
            value: false,
          },
          {
            text: "Hamilelik günlüğü tutun.",
            value: false,
          },
          {
            text: "Büyüyen göğüslerinize uyması için yeni bir veya iki sütyen alın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "Lekelenme yaşarsınız (Hamileliğin erken aşamalarında ortaya çıkabilmesine rağmen, lekelenme aynı zamanda erken düşük veya ektopik gebelik belirtisi olabilir)",
            value: false,
          },
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı veya yanma hissi yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 8,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Büyüyen rahminiz nedeniyle mide bağlarınız gerileceği için hamilelik krampları hissetmeye başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Göğüsleriniz hassas ve şişmiş hissedeceksiniz.",
            value: false,
          },
          {
            text: "Her zamankinden daha yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Kokulara karşı hassas olacaksınız.",
            value: false,
          },
          {
            text: "Dinlenirken bazal vücut ısınız yüksek kalacaktır.",
            value: false,
          },
          {
            text: "Mide bulantısı veya şişkinlik yaşamaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "İdrar yapma ihtiyacınız artacak.",
            value: false,
          },
          {
            text: "Cildinizde değişiklikler yaşayabilirsiniz, yani cildiniz daha kuru veya daha yağlı hale gelebilir.",
            value: false,
          },
          {
            text: "Ruh hali değişimleri yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Göğsünüze artan kan akışı nedeniyle varisli damarlar görünmeye başlayabilir.",
            value: false,
          },
          {
            text: "Belirli yiyecekler için can atmaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Kabızlık veya mide ekşimesi gibi sindirim sorunları yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Mümkün olduğunca koruyucu içeren yiyeceklerden kaçının.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "İlk doğum öncesi bakım randevusu (7. hafta ile 8. hafta arasında, isterseniz daha önce de olabilir!)",
            value: false,
          },
          {
            text: "Canlılık ultrasonu- hamileliğin normal şekilde ilerlediğini doğrulamak için",
            value: false,
          },
          {
            text: "Kan testleri (İlk trimesterde herhangi bir zamanda) - tam kan sayımı, kan grubu, hepatit, cinsel yolla bulaşan hastalıklar (HIV, Sifiliz) ve kızamıkçık, suçiçeği bağışıklığını kontrol etmek için",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzun Bilmesi Gerekenler",
        checklists: [
          {
            text: "Adet takviminiz ve son adet döneminizin tarihi",
            value: false,
          },
          {
            text: "Aile planlaması aracı ve daha önce kullanılan doğum kontrol hapı türleri",
            value: false,
          },
          {
            text: "Daha önce genital bir enfeksiyon geçirdiyseniz",
            value: false,
          },
          {
            text: "Herhangi bir anormal pap smear geçirdiyseniz",
            value: false,
          },
          {
            text: "Üreme organı ile ilgili herhangi bir sorun, hastalık veya ameliyat geçirdiyseniz",
            value: false,
          },
          {
            text: "Daha önce doğurganlık tedavisi aldıysanız",
            value: false,
          },
          {
            text: "Önceki kürtaj, düşük veya doğumla ilgili bilgiler",
            value: false,
          },
          {
            text: "Daha önce dış gebelik veya molar gebelik geçirdiyseniz",
            value: false,
          },
          {
            text: "Diyabet, hipertansiyon, epilepsi, kalp problemleri, tiroid bozuklukları, otoimmün bozukluklar veya herhangi bir ciddi hastalığınız varsa",
            value: false,
          },
          {
            text: "Şu anda hazımsızlık çekiyorsanız",
            value: false,
          },
          {
            text: "Daha önce kan nakli yaptırdıysanız",
            value: false,
          },
          {
            text: "Herhangi bir ilaç kullanıyorsanız",
            value: false,
          },
          {
            text: "Ailenizde kanser, diyabet, keloidler veya diğer kalıtsal hastalıklar gibi hastalık öyküsü",
            value: false,
          },
          {
            text: "Daha önce suçiçeği geçirdiyseniz veya suçiçeği ve difteri aşısı olduysanız",
            value: false,
          },
          {
            text: "Aşı geçmişiniz",
            value: false,
          },
          {
            text: "HPV aşısı yaptırdıysanız",
            value: false,
          },
          {
            text: "Ruh sağlığı geçmişiniz: herhangi bir depresyon geçmişi, anksiyete bozukluğu veya diğer akıl sağlığı bozuklukları",
            value: false,
          },
          {
            text: "Belirli ilaçlara, maddelere veya yiyeceklere alerjiniz varsa",
            value: false,
          },
          {
            text: "Daha önce anesteziyle ilgili sorun yaşadıysanız",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Hamilelik günlüğü tutun - Sizi endişelendiren herhangi bir şey varsa, doğum uzmanınızla konuşun.",
            value: false,
          },
          {
            text: "Reçetesiz alınabilen ilaçlar da olsa kendi kendine asla ilaç verme.",
            value: false,
          },
          {
            text: "Mide bulantısı veya akut yorgunluk çekiyorsanız, yeterince dinlenin.",
            value: false,
          },
          {
            text: "Hamilelik sırasında zihinsel ve fiziksel sağlığınız için eşinizden destek alın.",
            value: false,
          },
          {
            text: "Stresi en aza indirin ve günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Uygun egzersizi içeren sağlıklı bir yaşam tarzı benimseyin.",
            value: false,
          },
          {
            text: "Sert kimyasallarla güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Göğüslerinizin boyutu büyüdüyse, yeni bir sütyene ihtiyacınız olabilir.",
            value: false,
          },
          {
            text: "Rahat, pamuklu giysiler giyin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "Lekelenme yaşarsınız (Hamileliğin erken aşamalarında ortaya çıkabilmesine rağmen, lekelenme aynı zamanda erken düşük veya ektopik gebelik belirtisi olabilir)",
            value: false,
          },
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı veya yanma hissi yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 9,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Küçük çocuğunuzun hızlı büyümesi nedeniyle birkaç saatte bir aç hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız şişebilir.",
            value: false,
          },
          {
            text: "Bebeğiniz büyürken sırtınızdaki baskıdan sırt ağrısı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Bacak krampları yaşamaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Mide ekşimesi, hazımsızlık ve / veya kabızlık yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Çatlaklar görünmeye başlamış olabilir.",
            value: false,
          },
          {
            text: "Yüksek gebelik hormonları nedeniyle şiş, tahriş ve kanayan diş etleri yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Mümkün olduğunca koruyucu içeren yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
          {
            text: "Enfeksiyonlara yakalanmamak için sağlıklı ve hijyenik bir yaşam tarzı yönetin çünkü hamilelik sırasında bağışıklık sisteminiz zayıflıyor.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 15 kg arasındadır)",
            value: false,
          },
          {
            text: "Üçlü tarama veya dörtlü test (16 ve 18. Hafta arasında) - bebeğinizin nöral tüp defekti (NTD), Down sendromu veya diğer kromozomal kusurlara sahip olma riskini değerlendirmek için",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Amniyosentez (16. Hafta ile 20. Hafta Arasında) - kromozom anormalliklerini, nöral tüp kusurlarını ve genetik bozuklukları tespit eder",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gebelik diyabeti riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "35 yaşın üzerindeyseniz, amniyosentez testi yaptırmayı sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapma olasılığını sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Çocuğunuzun Down Sendromu ve trizomi 18 (kromozomal anormallikler) ve Spina Bifida gibi nöral tüp kusurlarına yakalanma riskinin yüksek olup olmadığını belirlemek için üçlü tarama gibi testleri sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Dik oturun ve hamilelik yogası gibi hafif egzersizler yapın.",
            value: false,
          },
          {
            text: "Yan tarafınız üzerinde uyuyun.",
            value: false,
          },
          {
            text: "Şişmişlerse ayaklarınızı kaldırın.",
            value: false,
          },
          {
            text: "Uyumadan önce nefes alma tekniklerini uygulayın.",
            value: false,
          },
          {
            text: "Bir profesyonel tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Daha iyi uyumanıza yardımcı olacak bir hamilelik yastığı alın.",
            value: false,
          },
          {
            text: "Kimyasal ve koruyucu içermeyen güvenli kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Sigara içenlerin yanında olmaktan kaçının.",
            value: false,
          },
          {
            text: "Ayaklarınız şişmiş ve boyutu artmışsa yeni ayakkabılar alın.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Stresten kaçının ve günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Karnınıza iyi bir çatlak kremi sürün.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak bebeğinizle daha yakın bir bağ kurmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bir doğum sınıfına kaydolun.",
            value: false,
          },
          {
            text: "İkinci üç aylık dönemdeki hamilelik dostu egzersizi hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinize ve bebek doğduktan sonrasına nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
          {
            text: "Doğum izninizi planlamaya başlayın - ne kadar hakkınız olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kötü kokuyorsanız",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 10,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Büyüyen rahminiz nedeniyle karın bağlarınız gerileceğinden hamilelik krampları hissetmeye başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Sık sık şişkin hissedecek ve şişkinlik yaşayacaksınız.",
            value: false,
          },
          {
            text: "Her zamankinden daha yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Koku duyunuz artacak.",
            value: false,
          },
          {
            text: "Hala mide bulantınız olabilir.",
            value: false,
          },
          {
            text: "Hormonal değişikliklerden sivilceleriniz olabilir.",
            value: false,
          },
          {
            text: "Ruh hali değişimleri yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Sırt ağrısı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Belirli yiyecekler için can atabilirsiniz.",
            value: false,
          },
          {
            text: "İştahınızı kaybedebilirsiniz.",
            value: false,
          },
          {
            text: "Artmış vajinal akıntı yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Şeker ve tuz alımınıza dikkat edin.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Mümkün olduğunca koruyucu içeren yiyeceklerden kaçının.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Beklenen bitiş tarihini (EDD) hesaplamak için ultrasonla tarihleme",
            value: false,
          },
          {
            text: "Boy, kilo ve vücut kitle indeksi (BMI) kontrolü",
            value: false,
          },
          {
            text: "Kan testleri (İlk trimesterde herhangi bir zamanda) - tam kan sayımı, kan grubu, hepatit, cinsel yolla bulaşan hastalıklar (HIV, Sifiliz) ve kızamıkçık, suçiçeği bağışıklığını kontrol etmek için",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Non-İnvaziv Prenatal Test (NIPT) (9. Hafta ile 14. Hafta Arasında) - Down Sendromu gibi kromozom bozukluklarını taramak için",
            value: false,
          },
          {
            text: "Koryonik Villus Örneklemesi (CVS) (10.Hafta ve 12.Hafta Arasında) - Down sendromu gibi kromozomal anormalliklerin test edilmesi",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Tahmini son tarihinizi sorun",
            value: false,
          },
          {
            text: "İster reçeteli ister reçetesiz olsun, kullandığınız herhangi bir ilaç hakkında doktorunuzla konuşun ve bunlara devam etmenin güvenli olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Preeklampsi ve gebelik diyabeti riski olup olmadığını sorun",
            value: false,
          },
          {
            text: "Doktorunuza genetik anormallikleri tespit etmek için gerekli testleri ve taramayı sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Spor veya egzersiz rutininize devam etmek için doktorunuza danışın.",
            value: false,
          },
          {
            text: "Zararlı kimyasallar kullanan güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Göğüs ölçünüzdeki değişikliklere uyum sağlamak için yeni bir sütyen alın.",
            value: false,
          },
          {
            text: "En yakın arkadaşlarınıza / akrabalarınıza hamileliğinizi anlatın.",
            value: false,
          },
          {
            text: "Soğuk algınlığı veya gripten kaçınmak için ellerinizi sık sık yıkayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları taşımaktan kaçının - ihtiyacınız olursa yardım isteyin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Sağlıklı beslenmeyi ve hangi yiyeceklerden kaçınmanız gerektiğini öğrenin.",
            value: false,
          },
          {
            text: "Bebek bütçesi oluşturun.",
            value: false,
          },
          {
            text: "Sağlık sigortanızın neleri kapsadığını veya sigortanız yoksa nasıl bakım alacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Emzirmeyi ve neden bu kadar önemli olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Bebeğinizi nerede doğuracağınıza dair araştırma - bebeğinizin hangi hastanede doğacağına karar vermek büyük bir karardır.",
            value: false,
          },
          {
            text: "Çalışıyorsanız işyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "Yöneticinize hamileliğiniz hakkında bilgi verin.",
            value: false,
          },
          {
            text: "Şirketinizin doğum izni politikaları ve sahip olduğunuz diğer haklar hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif hareketleri yapmayı, yürümeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Hamileliğiniz Yüksek Riskli Olabilir",
        checklists: [
          {
            text: "Fazla kilolu veya zayıfsanız",
            value: false,
          },
          {
            text: "Aneminiz varsa",
            value: false,
          },
          {
            text: "Ciddi bir enfeksiyonunuz varsa",
            value: false,
          },
          {
            text: "İkiz bebek veya fazlasını taşıyorsanız",
            value: false,
          },
          {
            text: "Kanser, epilepsi hastasıysanız, hipertansiyon veya başka bir ciddi sağlık durumu varsa",
            value: false,
          },
          {
            text: "Daha önce düşük, erken doğum, preeklampsi veya eklampsi geçirdiyseniz",
            value: false,
          },
          {
            text: "17 yaşın altında veya 35 yaşın üzerindeyseniz",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 11,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Belirtileri",
        checklists: [
          {
            text: "Bulantı ve kusma azalmaya başlayabilir.",
            value: false,
          },
          {
            text: "Hala baş ağrısı ve ruh hali değişimleri yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Her zamankinden daha yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Bu günlerde daha aç hissediyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Çok fazla şişkinlik, geğirme ve gaz problemi yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Ayrıca yemek yedikten sonra kendinizi rahatsız hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Ara sıra baygınlık hali veya baş dönmesi yaşıyor olabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Şeker ve tuz alımınıza dikkat edin.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Yavaşça ayağa kalkın, öğün atlamayın ve tek bir yerde uzun süre ayakta durmaktan kaçının. Bunlar baş dönmesini önlemeye yardımcı olur.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Mümkün olduğunca koruyucu içeren yiyeceklerden kaçının.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Boy, kilo ve vücut kitle indeksi (BMI) kontrolü",
            value: false,
          },
          {
            text: "Kan testleri (İlk trimesterde herhangi bir zamanda) - tam kan sayımı, kan grubu, hepatit, cinsel yolla bulaşan hastalıklar (HIV, Sifiliz) ve kızamıkçık, suçiçeği bağışıklığını kontrol etmek için",
            value: false,
          },
          {
            text: " Kan basıncı kontrolü ",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Non-İnvaziv Prenatal Test (NIPT) (9. Hafta ile 14. Hafta Arasında) - Down Sendromu gibi kromozom bozukluklarını taramak için",
            value: false,
          },
          {
            text: "Koryonik Villus Örneklemesi (CVS) (10.Hafta ve 12.Hafta Arasında) - Down sendromu gibi kromozomal anormalliklerin test edilmesi",
            value: false,
          },
          {
            text: "Fetal anomaliler için risk değerlendirmesi için tek durak klinik (OSCAR) (Hafta Arası 11 ve 14. Hafta) - kromozomal ve Down Sendromu ve trizomi 18 gibi diğer genetik bozuklukların riskini teşhis etmek ve hesaplamak için",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Doktorunuza tahmini son tarihinizi sorun.",
            value: false,
          },
          {
            text: "İster reçeteli ister reçetesiz olsun, kullandığınız herhangi bir ilaç hakkında doktorunuzla konuşun ve bunlara devam etmenin güvenli olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Preeklampsi ve gebelik diyabeti riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Doktorunuza genetik anormallikleri tespit etmek için gerekli testleri ve taramayı sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Spor veya egzersiz rutininize devam etmek için doktorunuza danışın.",
            value: false,
          },
          {
            text: "Zararlı kimyasallar kullanan güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Gerilirken, büyürken kaşıntılı ve kuru cildi önlemek için göbeğinizi, kalçalarınızı ve uyluklarınızı günlük olarak nemlendirin.",
            value: false,
          },
          {
            text: "Pelvik taban egzersizleri yapmak idrar sızıntılarını önleyebilir. Pelvik tabanınızı 10 saniye sıkın. Günde üç veya dört kez 10 tekrar yapın.",
            value: false,
          },
          {
            text: "Ev iş yükünü azaltın - eşinizden veya diğer aile üyelerinden yardım isteyin.",
            value: false,
          },
          {
            text: "Ellerinizi sık sık yıkayın ve temiz tutun.",
            value: false,
          },
          {
            text: "Ağır eşyaları taşımaktan kaçının - ihtiyacınız olursa yardım isteyin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Sağlıklı beslenme ve hangi yiyeceklerden kaçınmanız gerektiğini öğrenin.",
            value: false,
          },
          {
            text: "Bebek bütçesi oluşturun.",
            value: false,
          },
          {
            text: "Sağlık sigortanızın neleri kapsadığını veya sigortanız yoksa nasıl bakım alacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Emzirmeyi ve neden bu kadar önemli olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Bebeğinizi nerede doğuracağınıza dair araştırma yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "Yöneticinize hamileliğiniz hakkında bilgi verin.",
            value: false,
          },
          {
            text: " İşyerinizin doğum izni politikaları ve hakkınız olan diğer hakları öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra yürümeyi ya da hafif egzersizleri unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den daha yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Hamileliğiniz Yüksek Riskli Olabilir",
        checklists: [
          {
            text: "Fazla kilolu veya zayıfsanız",
            value: false,
          },
          {
            text: "Aneminiz varsa",
            value: false,
          },
          {
            text: "Ciddi bir enfeksiyonunuz varsa",
            value: false,
          },
          {
            text: "İkiz veya fazlasını taşıyorsanız",
            value: false,
          },
          {
            text: "Kanser, epilepsi, hipertansiyon veya başka bir ciddi sağlık durumunuz varsa",
            value: false,
          },
          {
            text: "Daha önce düşük, erken doğum, preeklampsi veya eklampsi geçirdiyseniz",
            value: false,
          },
          {
            text: "17 yaşın altında veya 35 yaşın üzerindeyseniz",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 12,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Semptomları",
        checklists: [
          {
            text: "Muhtemelen artık mide bulantısı ve kusma yaşamıyorsunuz ve iştahınız normale dönüyor.",
            value: false,
          },
          {
            text: "Diş etleriniz daha hassas olabilir; fırçaladığınızda veya diş ipi kullandığınızda bile kanayabilir.",
            value: false,
          },
          {
            text: "Ciltte renk değişikliği (kloazma veya melazma adı verilir) yavaş yavaş görünmeye başlayabilir.",
            value: false,
          },
          {
            text: "Baş dönmesi yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Karın kasları daha az aktif hale gelir, sizi kabızlığa ve şişkinliğe yatkın hale getirir.",
            value: false,
          },
          {
            text: "Karnınızın biraz gergin olduğunu ve eski giysilerinizin sıktığını hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Kokuya karşı giderek daha duyarlı olabilirsiniz.",
            value: false,
          },
          {
            text: "Rahminiz büyüdükçe mide krampları daha sık olabilir, özellikle aktifseniz veya öksürüyorsanız.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Yavaşça ayağa kalkın, öğün atlamayın ve tek bir yerde uzun süre ayakta durmaktan kaçının.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Şeker ve tuz alımınıza dikkat edin.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Mümkün olduğunca koruyucu içeren yiyeceklerden kaçının.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Boy, kilo ve vücut kitle indeksi (BMI) kontrolü",
            value: false,
          },
          {
            text: "Kan testleri (İlk trimesterde herhangi bir zamanda) - tam kan sayımı, kan grubu, hepatit, cinsel yolla bulaşan hastalıklar (HIV, Sifiliz) ve kızamıkçık, suçiçeği bağışıklığını kontrol etmek için",
            value: false,
          },
          {
            text: " Kan basıncı kontrolü ",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Non-İnvazif Prenatal Test (NIPT) (9. Hafta ile 14. Hafta Arasında) - Down Sendromu gibi kromozomal bozuklukları taramak için",
            value: false,
          },
          {
            text: "Koryonik Villus Örneklemesi (CVS) (10.Hafta ve 12.Hafta Arasında) - Down sendromu gibi kromozomal anormalliklerin test edilmesi",
            value: false,
          },
          {
            text: "Kromozomal ve Down Sendromu ve trizomi 18 gibi diğer genetik bozuklukların teşhisi ve riskinin hesaplanması için fetal anomaliler için risk değerlendirmesi (OSCAR) için tek noktadan klinik (11.Hafta ve 14. Hafta Arasında)",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Doktorunuza tahmini son tarihinizi sorun.",
            value: false,
          },
          {
            text: "İster reçeteli ister reçetesiz olsun, kullandığınız herhangi bir ilaç hakkında doktorunuzla konuşun ve bunlara devam etmenin güvenli olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Preeklampsi ve gebelik diyabeti riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Doktorunuza genetik anormallikleri tespit etmek için gerekli testleri ve taramayı sorun.",
            value: false,
          },
          {
            text: "Doktorunuzdan grip ve diğer aşılar konusunda bilgi alın.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatıcılar",
        checklists: [
          {
            text: "Günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Spor veya egzersiz rutininize devam etmek için doktorunuza danışın.",
            value: false,
          },
          {
            text: "Esnek üstler ve elbiseler gibi daha büyük kıyafetler için alışverişe başlayın.",
            value: false,
          },
          {
            text: "Zararlı kimyasallar kullanan güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Büyüme sebepli gerilirken kaşıntılı ve kuru cildi önlemek için göbeğinizi, kalçalarınızı ve uyluklarınızı günlük olarak nemlendirin.",
            value: false,
          },
          {
            text: "Pelvik taban egzersizleri yapmak idrar sızıntılarını önleyebilir. Pelvik tabanınızı 10 saniye sıkın. Günde üç veya dört kez 10 tekrar yapın.",
            value: false,
          },
          {
            text: "Dişlerinize iyi bakın. Günde iki kez iyice fırçaladığınızdan ve haftada en az üç kez diş ipi kullandığınızdan emin olun.",
            value: false,
          },
          {
            text: "Sırt üstü uyumaktan kaçının - bunun yerine yan yatarak uyuyun.",
            value: false,
          },
          {
            text: "Ellerinizi sık sık yıkayın ve temiz tutun.",
            value: false,
          },
          {
            text: "Ağır eşyaları taşımaktan kaçının - ihtiyacınız olursa yardım isteyin.",
            value: false,
          },
          {
            text: "Doktorunuzun onayıyla hamilelik egzersiz veya yogasına devam edin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Araştırması",
        checklists: [
          {
            text: "Sağlıklı beslenme ve hangi yiyeceklerden kaçınmanız gerektiğini öğrenin.",
            value: false,
          },
          {
            text: "Doğum yapılacak hastaneleri araştırın - seçerken hastanenin evinizden ne kadar uzakta olduğunu düşünmeyi unutmayın.",
            value: false,
          },
          {
            text: "Bebek bütçesi oluşturun.",
            value: false,
          },
          {
            text: "Hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Emzirmeyi ve neden bu kadar önemli olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Sağlık sigortanızın neleri kapsadığını veya sigortanız yoksa nasıl bakım alacağınızı öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "İşyerinizin doğum izni politikaları ve hakkınız olan diğer hakları öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif yürüyüş ve hareketler yapmayı unutmayın.",
            value: false,
          },
          {
            text: "Yöneticinize hamileliğiniz hakkında bilgi verin.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Hamileliğiniz Yüksek Riskli Olabilir",
        checklists: [
          {
            text: "Fazla kilolu veya zayıfsanız",
            value: false,
          },
          {
            text: "Aneminiz varsa",
            value: false,
          },
          {
            text: "Ciddi bir enfeksiyonunuz varsa",
            value: false,
          },
          {
            text: "İkiz veya fazlasını taşıyorsanız",
            value: false,
          },
          {
            text: "Kanser, epilepsi, hipertansiyon veya başka bir ciddi sağlık durumunuz varsa",
            value: false,
          },
          {
            text: "Daha önce düşük, erken doğum, preeklampsi veya eklampsi geçirdiyseniz",
            value: false,
          },
          {
            text: "17 yaşın altında veya 35 yaşın üzerindeyseniz",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 13,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Muhtemelen artık bulantı ve kusma yaşamıyorsunuz ve iştahınız normale dönüyor.",
            value: false,
          },
          {
            text: "Hamileliğinizin bu noktasında lösore olarak bilinen berrak ve süt rengi bir akıntı artabilir.",
            value: false,
          },
          {
            text: "Rahminiz büyüdükçe mide krampları, özellikle hareketliyken veya öksürürken daha sık olabilir.",
            value: false,
          },
          {
            text: "Diş eti iltihabı yaşayabilirsiniz, özellikle dişlerinize düzgün bakmazsanız.",
            value: false,
          },
          {
            text: "Muhtemelen hamilelik parıltısını almaya başlıyorsunuz.",
            value: false,
          },
          {
            text: "Saçlarınız daha dolgun ve daha parlak hissedecek.",
            value: false,
          },
          {
            text: "Baş dönmesi yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Kabızlık, mide ekşimesi ve / veya hazımsızlık yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Cinsel istekte bir artış veya azalma hissedebilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Şeker ve tuz alımınıza dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Boy, kilo ve vücut kitle indeksi (BMI) kontrolü",
            value: false,
          },
          {
            text: " Kan basıncı kontrolü ",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Non-İnvazif Prenatal Test (NIPT) (9. Hafta ile 14. Hafta Arasında) - Down Sendromu gibi kromozomal bozuklukları taramak için",
            value: false,
          },
          {
            text: "Kromozomal ve Down Sendromu ve trizomi 18 gibi diğer genetik bozuklukların teşhisi ve riskinin hesaplanması için fetal anomaliler için risk değerlendirmesi (OSCAR) için tek noktadan klinik",
            value: false,
          },
          {
            text: "Diş sağlığınızı kontrol ettirmek için diş hekimini ziyaret edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Durumunuzu ve tahmini son tarihinizi sorun.",
            value: false,
          },
          {
            text: "Herhangi bir preeklampsi ve gebelik diyabeti riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Doktorunuza genetik anormallikleri tespit etmek için gerekli testleri ve taramayı sorun.",
            value: false,
          },
          {
            text: "Doğru miktarda kilo alıp almadığınızı sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatıcılar",
        checklists: [
          {
            text: "Herhangi bir konuda endişeleniyorsanız doğum uzmanınıza danışın.",
            value: false,
          },
          {
            text: "Reçetesiz alınabilen ilaçlar da olsa kendi kendine asla ilaç verme.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Spor veya egzersiz rutininize devam etmek için doktorunuza danışın.",
            value: false,
          },
          {
            text: "Esnek üstler ve elbiseler gibi daha büyük kıyafetler için alışverişe başlayın.",
            value: false,
          },
          {
            text: "Zararlı kimyasallar kullanan güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Büyüme nedenli gerilirken kaşıntılı ve kuru cildi önlemek için göbeğinizi, kalçalarınızı ve uyluklarınızı günlük olarak nemlendirin.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak bebeğinizi canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Bebeğiniz için bir tasarruf hesabı açın.",
            value: false,
          },
          {
            text: "Sırt üstü uyumaktan kaçının ve onun yerine yan yatarak uyuyun.",
            value: false,
          },
          {
            text: "Ellerinizi sık sık yıkayın ve temiz tutun.",
            value: false,
          },
          {
            text: "Ağır eşyaları taşımaktan kaçının - ihtiyacınız olursa yardım isteyin.",
            value: false,
          },
          {
            text: "Deneyimli bir masöz tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Bu ikinci gebeliğiniz veya daha fazlaysa, ilk çocuğunuzu yeni hamileliğinize hazırlayın.",
            value: false,
          },
          {
            text: "Bu ikinci hamileliğiniz veya daha fazlaysa, ilk çocuğunuzu yeni kız kardeşi / erkek kardeşi için hazırlayın.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi yapın. Pelvik tabanınızı 10 saniye sıkın. Günde üç veya dört kez 10 tekrar yapın",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Araştırması",
        checklists: [
          {
            text: "Sağlıklı beslenme ve hangi yiyeceklerden kaçınmanız gerektiğini öğrenin.",
            value: false,
          },
          {
            text: "Doğum yapılacak hastaneleri araştırın (Birini seçerken hastanenin evinizden ne kadar uzakta olduğunu düşünmeyi unutmayın).",
            value: false,
          },
          {
            text: "Farklı doğum yöntemleri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Doğum öncesi balayı rotalarını, mekanlarını araştırın.",
            value: false,
          },
          {
            text: "Emzirmeyi ve neden bu kadar önemli olduğunu öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "İşyerinizin doğum izni politikalarını ve diğer haklarınızı öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre oturduğunuzda kalkıp hafif yürüyüş ve egzersiz yapmayı unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Hamileliğiniz Yüksek Riskli Olabilir",
        checklists: [
          {
            text: "Fazla kilolu veya zayıfsanız",
            value: false,
          },
          {
            text: "Aneminiz varsa",
            value: false,
          },
          {
            text: "Ciddi bir enfeksiyonunuz varsa",
            value: false,
          },
          {
            text: "İkiz veya fazlasını taşıyorsanız",
            value: false,
          },
          {
            text: "Kanser, epilepsi, hipertansiyon veya başka bir ciddi sağlık durumunuz varsa",
            value: false,
          },
          {
            text: "Daha önce düşük, erken doğum, preeklampsi veya eklampsi geçirdiyseniz",
            value: false,
          },
          {
            text: "17 yaşın altında veya 35 yaşın üzerindeyseniz",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 14,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Muhtemelen görünür bir bebek yumruğunuz, karın çıkıntınız olacak.",
            value: false,
          },
          {
            text: "Mide bulantısı durduğuna ve iştahınızı geri kazandığınıza göre daha sık acıkabilirsiniz.",
            value: false,
          },
          {
            text: "Özellikle sırt ve karın bölgesinde rahatsızlık veya ağrı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Saçınız daha kalın ve cildiniz ışıl ışıl olacak.",
            value: false,
          },
          {
            text: "Eklemleriniz daha gevşek olduğu için daha beceriksiz ve sakar olabilirsiniz.",
            value: false,
          },
          {
            text: "Burun tıkanıklığınız olabilir ve daha yüksek gebelik hormonu seviyeleri nedeniyle ara sıra burun kanaması olabilir.",
            value: false,
          },
          {
            text: "Bacaklarınızda ve ayaklarda varisli damarlarınız veya genişlemiş damarlarınız olabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Günde en az 400 mcg folik asit alın - Bu bebeğinizin beyin ve omurilik gelişimi için önemlidir.",
            value: false,
          },
          {
            text: "Günde10-12 bardak su için",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Koruyucu içeren gıdalardan mümkün olduğunca kaçının.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
          {
            text: "Sırt ağrısından kaçınmak için dik oturun.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Boy, kilo ve vücut kitle indeksi (BMI) kontrolü",
            value: false,
          },
          {
            text: " Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Non-İnvazif Prenatal Test (NIPT) (9. Hafta ile 14. Hafta Arasında) - Down Sendromu gibi kromozomal bozuklukları taramak için",
            value: false,
          },
          {
            text: "Fetal anomaliler için risk değerlendirmesi için tek durak klinik (OSCAR) (Hafta Arası 11 ve 14. Hafta) - kromozomal ve Down Sendromu ve trizomi 18 gibi diğer genetik bozuklukların riskini teşhis etmek ve hesaplamak için",
            value: false,
          },
          {
            text: "Diş sağlığınızı korumak için diş hekimini ziyaret edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Doktorunuza durumunuzu ve tahmini son tarihinizi sorun.",
            value: false,
          },
          {
            text: "Preeklampsi ve gebelik diyabeti riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Doktorunuza genetik anormallikleri tespit etmek için gerekli testleri ve taramayı sorun.",
            value: false,
          },
          {
            text: "Doğru miktarda kilo alıp almadığınızı sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Vücudunuzu doğuma hazırlamak için hamilelik derslerine kaydolun.",
            value: false,
          },
          {
            text: "Şık hamile kıyafetleri alın.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Sizi endişelendiren her şeyi not edin ve kadın doğum uzmanınızla şüphelerinizi giderin.",
            value: false,
          },
          {
            text: "Rahatlamak için meditasyon yapın.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Zararlı kimyasallar kullanan güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Spor veya egzersiz rutininize devam etmek için doktorunuza danışın.",
            value: false,
          },
          {
            text: "Çatlakları en aza indirmek için karnınızda iyi krem kullanmaya başlayın.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak ve rahatlatıcı, sakinleştirici müzikler çalarak bebeğinizi canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Doğum hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Sırt üstü uyumaktan kaçının - Onun yerine yan yatarak uyuyun.",
            value: false,
          },
          {
            text: "Ellerinizi sık sık yıkayın ve temiz tutun.",
            value: false,
          },
          {
            text: "Ağır eşyalar taşımaktan kaçının - İhtiyacınız olursa yardım isteyin.",
            value: false,
          },
          {
            text: "Deneyimli bir masöz tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Bu ikinci hamileliğiniz veya daha fazlaysa, ilk çocuğunuzu yeni kız kardeşi / erkek kardeşi için hazırlayın.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi yapın. Pelvik tabanınızı 10 saniye sıkın. Günde üç veya dört kez 10 tekrar yapın.",
            value: false,
          },
          {
            text: "Doğum öncesi balayı için plan yapın!",
            value: false,
          },
          {
            text: "Rahatsızlığınızı gidermek için yoga ve pilates yapın.",
            value: false,
          },
          {
            text: "Düşmenize neden olabilecek yoğun egzersizden kaçının.",
            value: false,
          },
          {
            text: "Çocuğunuz için bir tasarruf fonu açmayı düşünün.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bölgenizdeki doğum öncesi kursları hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Emzirmeyi ve neden bu kadar önemli olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinizde ve bebek doğduktan sonra nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
          {
            text: "Hangi hastanede doğum yapacağınıza karar verin. Birini seçerken hastanenin evinizden ne kadar uzakta olduğunu düşünmeyi unutmayın. Ayrıca, doğum uzmanınızın o hastaneyi ziyaret edip etmediğini kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "İşyerinizin doğum izni politikalarını ve diğer haklarınızı öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, zaman zaman vücudunuzu esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 15,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Burun ve diş etleriniz, artan gebelik hormonları seviyesinden dolayı şişebilir.",
            value: false,
          },
          {
            text: "Diş etleriniz kanayabilir.",
            value: false,
          },
          {
            text: "Süt rengi vajinal akıntınız olabilir.",
            value: false,
          },
          {
            text: "Sırt ağrısı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Meme uçlarınız kararabilir ve büyüyebilir.",
            value: false,
          },
          {
            text: " Kabızlık, mide ekşimesi ve / veya hazımsızlık yaşıyor olabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Hamilelik sırasında bağışıklık sisteminiz zayıfladığından enfeksiyonlara yakalanmamak için sağlıklı bir yaşam tarzı yönetin.",
            value: false,
          },
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Yeterli miktarda kalsiyum ve kalsiyumun emilmesine yardımcı olacak D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Koruyucu içeren gıdalardan mümkün olduğunca kaçının.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Doktorunuzun önerdiği şekilde gerekli kan testlerini yapın.",
            value: false,
          },
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şişip şişmediğini kontrol edin.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü ",
            value: false,
          },

          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "İdrarınızdaki protein seviyelerini kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Çocuğunuzun Down Sendromu ve trizomi 18 (kromozomal anormallikler) ve Spina Bifida gibi nöral tüp kusurlarına yakalanma riskinin yüksek olup olmadığını belirlemek için testler isteyin.",
            value: false,
          },
          {
            text: "35 yaşın üzerindeyseniz, amniyosentez testi yaptırmayı sorun.",
            value: false,
          },
          {
            text: "Doğum seçeneklerini sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Sağlıklı kalabilmek için çevrenizi temiz tutun.",
            value: false,
          },
          {
            text: "Ellerinizi düzenli olarak yıkayın ve kendinizi soğuk algınlığı veya gripten korumak için her zaman yanınızda bir dezenfektan bulundurun.",
            value: false,
          },
          {
            text: "Sizin ve eşiniz için güvenli ve rahat cinsel pozisyonlar bulun.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Rahatlamak için meditasyon yapın.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Vücudunuzu doğuma hazırlamak için hamilelik derslerine kaydolun.",
            value: false,
          },
          {
            text: "Sizi endişelendiren tüm koşulları not edin ve bunlar hakkında doğum uzmanınıza danışın.",
            value: false,
          },
          {
            text: "Zararlı kimyasallar kullanan güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Çatlakları en aza indirmek için karnınızda iyi bir leke kremi kullanmaya başlayın.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak ve rahatlatıcı, sakinleştirici müzikler çalarak bebeğinizi uyarmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Sırt üstü uyumaktan kaçının - onun yerine yan yatarak uyuyun.",
            value: false,
          },
          {
            text: "Ellerinizi sık sık yıkayın ve temiz tutun.",
            value: false,
          },
          {
            text: "Ağır eşyaları taşımaktan kaçının - ihtiyacınız olursa yardım isteyin.",
            value: false,
          },
          {
            text: "Deneyimli bir masöz tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Bu ikinci hamileliğiniz veya daha fazlaysa, ilk çocuğunuzu yeni kız kardeşi / erkek kardeşi için hazırlayın.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi yapın. Pelvik tabanınızı 10 saniye sıkın. Günde üç veya dört kez 10 tekrar yapın.",
            value: false,
          },
          {
            text: "Doğum öncesi balayı için plan yapın!",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Farklı doğum yöntemleri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Emzirme ve neden bu kadar önemli olduğu hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinize ve bebek doğduktan sonra nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
          {
            text: "Hangi hastanede doğum yapacağınıza karar verin - hastanenin evinizden ne kadar uzakta olduğunu düşünmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "İşyerinizin doğum izni politikalarını ve diğer haklarınızı öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 15,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Burun ve diş etleriniz, artan gebelik hormonları seviyesinden dolayı şişebilir.",
            value: false,
          },
          {
            text: "Diş etleriniz kanayabilir.",
            value: false,
          },
          {
            text: "Süt rengi vajinal akıntınız olabilir.",
            value: false,
          },
          {
            text: "Sırt ağrısı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Meme uçlarınız kararabilir ve büyüyebilir.",
            value: false,
          },
          {
            text: " Kabızlık, mide ekşimesi ve / veya hazımsızlık yaşıyor olabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Hamilelik sırasında bağışıklık sisteminiz zayıfladığından enfeksiyonlara yakalanmamak için sağlıklı bir yaşam tarzı yönetin.",
            value: false,
          },
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Yeterli miktarda kalsiyum ve kalsiyumun emilmesine yardımcı olacak D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Koruyucu içeren gıdalardan mümkün olduğunca kaçının.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Doktorunuzun önerdiği şekilde gerekli kan testlerini yapın.",
            value: false,
          },
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şişip şişmediğini kontrol edin.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "İdrarınızdaki protein seviyelerini kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Çocuğunuzun Down Sendromu ve trizomi 18 (kromozomal anormallikler) ve Spina Bifida gibi nöral tüp kusurlarına yakalanma riskinin yüksek olup olmadığını belirlemek için testler isteyin.",
            value: false,
          },
          {
            text: "35 yaşın üzerindeyseniz, amniyosentez testi yaptırmayı sorun.",
            value: false,
          },
          {
            text: "Doğum seçeneklerini sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Sağlıklı kalabilmek için çevrenizi temiz tutun.",
            value: false,
          },
          {
            text: "Ellerinizi düzenli olarak yıkayın ve kendinizi soğuk algınlığı veya gripten korumak için her zaman yanınızda bir dezenfektan bulundurun.",
            value: false,
          },
          {
            text: "Sizin ve eşiniz için güvenli ve rahat cinsel pozisyonlar bulun.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Rahatlamak için meditasyon yapın.",
            value: false,
          },
          {
            text: "Günde en az 8 saat uyuyun.",
            value: false,
          },
          {
            text: "Vücudunuzu doğuma hazırlamak için hamilelik derslerine kaydolun.",
            value: false,
          },
          {
            text: "Sizi endişelendiren tüm koşulları not edin ve bunlar hakkında doğum uzmanınıza danışın.",
            value: false,
          },
          {
            text: "Zararlı kimyasallar kullanan güzellik bakımlarından kaçının.",
            value: false,
          },
          {
            text: "Çatlakları en aza indirmek için karnınızda iyi bir leke kremi kullanmaya başlayın.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak ve rahatlatıcı, sakinleştirici müzikler çalarak bebeğinizi uyarmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Sırt üstü uyumaktan kaçının - onun yerine yan yatarak uyuyun.",
            value: false,
          },
          {
            text: "Ellerinizi sık sık yıkayın ve temiz tutun.",
            value: false,
          },
          {
            text: "Ağır eşyaları taşımaktan kaçının - ihtiyacınız olursa yardım isteyin.",
            value: false,
          },
          {
            text: "Deneyimli bir masöz tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Bu ikinci hamileliğiniz veya daha fazlaysa, ilk çocuğunuzu yeni kız kardeşi / erkek kardeşi için hazırlayın.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi yapın. Pelvik tabanınızı 10 saniye sıkın. Günde üç veya dört kez 10 tekrar yapın.",
            value: false,
          },
          {
            text: "Doğum öncesi balayı için plan yapın!",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Farklı doğum yöntemleri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Emzirme ve neden bu kadar önemli olduğu hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinize ve bebek doğduktan sonra nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
          {
            text: "Hangi hastanede doğum yapacağınıza karar verin - hastanenin evinizden ne kadar uzakta olduğunu düşünmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "İşyerinizin doğum izni politikaları ve hakkınız olan diğer hakları öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 16,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: 'Bebeğinizin ilk vuruşlarını hissedebilirsiniz - Bu "hızlanma" olarak bilinir ve yumuşak baloncuklar veya karnınızda kanat çırpınan bir kelebek gibi hissedebilirsiniz!',
            value: false,
          },
          {
            text: "Diş etleriniz kırmızı, şişmiş olabilir ve hatta dişlerinizi fırçalarken veya diş ipi kullandığınızda ağrılı, hassas veya kanamaya yatkın olabilirler.",
            value: false,
          },
          {
            text: "Rahminiz bağırsaklarınıza baskı yaparken kabızlık yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Saçlarınız ve tırnaklarınız daha hızlı uzamaya başlar.",
            value: false,
          },
          {
            text: "Kuru ve kaşıntılı cilt deneyimi yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Mide ekşimesi yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Daha unutkan olabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Yeterli miktarda kalsiyum ve kalsiyumun emilmesine yardımcı olacak D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Koruyucu içeren gıdalardan mümkün olduğunca kaçının.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
          {
            text: "Enfeksiyonlara yakalanmamak için sağlıklı bir yaşam tarzı sürdürün çünkü bağışıklık sisteminiz daha zayıftır.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Doktorunuzun önerdiği şekilde gerekli kan testlerini yapın.",
            value: false,
          },
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şişip şişmediğini kontrol edin.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Amniyosentez (16. Hafta ile 20. Hafta Arasında) - kromozom anormalliklerini, nöral tüp kusurlarını ve genetik bozuklukları tespit eder.",
            value: false,
          },
          {
            text: "Üçlü tarama veya dörtlü test (16 ve 18. Hafta arasında) - bebeğinizin nöral tüp defekti (NTD), Down sendromu veya diğer kromozomal kusurlara sahip olma riskini değerlendirmek için.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Çocuğunuzun Down Sendromu ve trizomi 18 (kromozomal anormallikler) ve Spina Bifida gibi nöral tüp kusurlarına yakalanma riskinin yüksek olup olmadığını belirlemek için testler isteyin.",
            value: false,
          },
          {
            text: "35 yaşın üzerindeyseniz, amniyosentez testi yaptırmayı sorun.",
            value: false,
          },
          {
            text: "Doğum seçeneklerini sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Çatlakların görünümünü azaltmak için iyi bir nemlendirici kullanın.",
            value: false,
          },
          {
            text: "Eşinizin bebeğinizle konuşmasını isteyin, böylece babasının sesine aşina olsun.",
            value: false,
          },
          {
            text: "Hamilelik sınıfına kaydolun.",
            value: false,
          },
          {
            text: "Unutkan olduğunuzu düşünüyorsanız, yapmanız gereken şeyleri listeleyin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Farklı doğum yöntemleri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "İkinci üç aylık dönemdeki hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Emzirmeyi ve neden bu kadar önemli olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinize ve bebek doğduktan sonra nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
          {
            text: "Bebeğinizin bu hafta ne yaptığını öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "İşyerinizin doğum izni politikalarını ve diğer haklarınızı öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 17,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Bebeğiniz büyümeye devam ederken kilo alırsınız.",
            value: false,
          },
          {
            text: "Karnınızda, göğsünüzde ve hatta kollarınızda ve uyluklarınızda çatlaklar fark edebilirsiniz.",
            value: false,
          },
          {
            text: "Kan akışındaki ve vücut sıvılarındaki artış nedeniyle daha fazla terleyebilirsiniz.",
            value: false,
          },
          {
            text: "Karnınızın ortasında koyu renkli bir çizgi beliriyor olabilir. Buna linea nigra denir.",
            value: false,
          },
          {
            text: "Bu günlerde muhtemelen daha aç hissedeceksiniz.",
            value: false,
          },
          {
            text: "Hormon seviyelerindeki değişiklikler ciltte pigmentasyona neden olabilir.",
            value: false,
          },
          {
            text: "Mide ekşimesi, hazımsızlık ve / veya kabızlık yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Uykunuz bacak krampları ile kesintiye uğrayabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Yeterli miktarda kalsiyum ve kalsiyumun emilmesine yardımcı olacak D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Koruyucu içeren gıdalardan mümkün olduğunca kaçının.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
          {
            text: "Enfeksiyonlara yakalanmamak için sağlıklı bir yaşam tarzı sürdürün çünkü bağışıklık sisteminiz daha zayıftır.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Doktorunuzun önerdiği şekilde gerekli kan testlerini yapın.",
            value: false,
          },
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Henüz yapmadıysanız diş hekiminizi ziyaret edin.",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şişip şişmediğini kontrol edin.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Amniyosentez (16. Hafta ile 20. Hafta Arasında) - kromozom anormalliklerini, nöral tüp kusurlarını ve genetik bozuklukları tespit eder.",
            value: false,
          },
          {
            text: "Üçlü tarama veya dörtlü test (16 ve 18. Hafta arasında) - bebeğinizin nöral tüp defekti (NTD), Down sendromu veya diğer kromozomal kusurlara sahip olma riskini değerlendirmek için.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Çocuğunuzun Down Sendromu ve trizomi 18 (kromozomal anormallikler) ve Spina Bifida gibi nöral tüp kusurlarına yakalanma riskinin yüksek olup olmadığını belirlemek için testler isteyin.",
            value: false,
          },
          {
            text: "35 yaşın üzerindeyseniz, amniyosentez testi yaptırmayı sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Hamilelik yastığı daha iyi uyumanıza yardımcı olur.",
            value: false,
          },
          {
            text: "Kullanmanız için güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Sol tarafınızda uyuyun, asla sırt üstü yatmayın.",
            value: false,
          },
          {
            text: "Ayakkabı numaranız artabileceğinden yeni ayakkabılara ihtiyacınız olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Hamilelik sınıfına kaydolun.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Meditasyon yoluyla rahatlamayı öğrenin.",
            value: false,
          },
          {
            text: "Stresten kaçının ve günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Karnınıza iyi bir çatlak kremi ​​sürün.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Çocuğunuz için bir tasarruf fonu açmayı düşünün.",
            value: false,
          },
          {
            text: "Ellerinizi sık sık yıkayın ve temiz tutun.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi uygulayın. Pelvik tabanınızı 10 saniye sıkın. Bir kilin üç veya dört kez 10 tekrar yapın.",
            value: false,
          },
          {
            text: "Doğum öncesi balayı planlarını tamamlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bir doğum sınıfına kaydolun.",
            value: false,
          },
          {
            text: "İkinci üç aylık dönemdeki hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinize ve bebek doğduktan sonra nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşyerinizin hamile kadınlara yönelik politikalarını öğrenin.",
            value: false,
          },
          {
            text: "Çalışma ve ofis ortamlarınızın hamileliğiniz için herhangi bir risk oluşturup oluşturmadığını öğrenin.",
            value: false,
          },
          {
            text: "İşyerinizin doğum izni politikalarını ve diğer haklarınızı öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 18,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Küçük bebeğinizin hızlı büyümesi nedeniyle birkaç saatte bir aç hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız şişebilir.",
            value: false,
          },
          {
            text: "Bebeğin büyümesi nedeniyle sırtınızdaki baskıdan sırt ağrısı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Bacak krampları yaşamaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Mide ekşimesi, hazımsızlık ve / veya kabızlık yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Çatlaklar görünmeye başlamış olabilir.",
            value: false,
          },
          {
            text: "Gebelik hormonlarının yükselmesi nedeniyle şişmiş, tahriş olmuş ve kanamalı diş etleri yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Bebeğinizin beyin ve omurilik gelişimi için günde en az 400 mcg folik asit alın.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için demir açısından zengin yiyecekler yiyin.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Kafein alımınızı günde bir fincandan fazla olmayacak şekilde azaltın.",
            value: false,
          },
          {
            text: "Çiğ yiyecek tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Doktorunuz tarafından önerilen bir hamilelik vitamini alın.",
            value: false,
          },
          {
            text: "Yeterli miktarda kalsiyum ve kalsiyumun emilmesine yardımcı olacak D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Koruyucu içeren gıdalardan mümkün olduğunca kaçının.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
          {
            text: "Enfeksiyonlara yakalanmamak için sağlıklı bir yaşam tarzı sürdürün çünkü bağışıklık sisteminiz daha zayıftır.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Henüz yapmadıysanız diş hekiminizi ziyaret edin.",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şişip şişmediğini kontrol edin.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Amniyosentez (16. Hafta ile 20. Hafta Arasında) - kromozom anormalliklerini, nöral tüp kusurlarını ve genetik bozuklukları tespit eder.",
            value: false,
          },
          {
            text: "Üçlü tarama veya dörtlü test (16 ve 18. Hafta arasında) - bebeğinizin nöral tüp defekti (NTD), Down sendromu veya diğer kromozomal kusurlara sahip olma riskini değerlendirmek için.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Çocuğunuzun Down Sendromu ve trizomi 18 (kromozomal anormallikler) ve Spina Bifida gibi nöral tüp kusurlarına yakalanma riskinin yüksek olup olmadığını belirlemek için testler isteyin.",
            value: false,
          },
          {
            text: "35 yaşın üzerindeyseniz, amniyosentez testi yaptırmayı sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Dik oturun ve hamilelik yogası gibi hafif egzersizler yapın.",
            value: false,
          },
          {
            text: "Sırtüstü uyumak kan akışını kısıtlayıp baş dönmesine neden olabileceğinden yan yatarak uyuyun.",
            value: false,
          },
          {
            text: "Şişmişlerse ayaklarınızı kaldırın.",
            value: false,
          },
          {
            text: "Bir profesyonel tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Daha iyi uyumanıza yardımcı olacak bir hamilelik yastığı alın.",
            value: false,
          },
          {
            text: "Kimyasal ve koruyucu içermeyen güvenli kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Sigara içenlerin yanında olmaktan kaçının.",
            value: false,
          },
          {
            text: "Ayaklarınız şişmiş ve boyutu artmışsa yeni ayakkabılar alın.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Stresten kaçının ve en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Karnınıza iyi bir nemlendirici krem ​​sürün.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Arkadaşlarınızla görüşmek için zaman ayırın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bir doğum sınıfına kaydolun.",
            value: false,
          },
          {
            text: "İkinci üç aylık dönemdeki hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinize ve bebek doğduktan sonra nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninizi planlamaya başlayın - ne kadar hakkınız olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 19,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Büyüyen rahim bağlarınızı gerdiği için karın ağrısı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzdan minik tekmeler ve hareketler hissedeceksiniz.",
            value: false,
          },
          {
            text: "Mide ekşimesi yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Daha aç olabilirsiniz.",
            value: false,
          },
          {
            text: "Çatlaklar görünmeye başlamış olabilir.",
            value: false,
          },
          {
            text: "Burnunuz tıkalı olabilir.",
            value: false,
          },
          {
            text: "Daha çok terler ve daha sıcak hissedersiniz.",
            value: false,
          },
          {
            text: "Baş dönmesi yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Geceleri bacak krampları olabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için kırmızı et, kümes hayvanları, balık, mercimek, yeşil yapraklı sebzeler ve tam tahıllar gibi demir açısından zengin besinler tüketin.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Ayrıntılı fetal anomali taraması (19.Hafta ile 22. Hafta Arasında) - fetustaki yapısal anormallikleri ve plasental pozisyon gibi diğer ayrıntıları kontrol etmek için",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Amniyosentez (16. Hafta ile 20. Hafta Arasında) - kromozom anormalliklerini, nöral tüp kusurlarını ve genetik bozuklukları tespit eder.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "35 yaşın üzerindeyseniz, amniyosentez testi yaptırmayı sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Hala öğrenemediyseniz bebeğinizin cinsiyetini sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Yürümeyi ve basit egzersizler yapmayı deneyin - bunlar sizi zinde tutacak ve hamilelik ağrılarını ve sancılarını hafifletecektir.",
            value: false,
          },
          {
            text: "Sersemlemiş hissediyorsanız oturun ve nefes egzersizleri yapın.",
            value: false,
          },
          {
            text: "Kalça, bel ağrısını hafifletmek için dizlerinizin arasına sıkıştırılmış bir yastıkla uyuyun.",
            value: false,
          },
          {
            text: "Eşinizden bebeğin tekmelerini hissetmesini de isteyin.",
            value: false,
          },
          {
            text: "Bebeğiniz için isimler düşünmeye başlayın.",
            value: false,
          },
          {
            text: "Ağır şeyleri kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Vücudunuzun etrafındaki kan akışını kısıtlayabileceği için sırt üstü yatmayın.",
            value: false,
          },
          {
            text: "Yana dönerek uyuyun (tercihen sol tarafta).",
            value: false,
          },
          {
            text: "Çok yorulmayın; vücudunuzu dinleyin!",
            value: false,
          },
          {
            text: "Kimyasal ve koruyucu içermeyen güvenli kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın bir fotoğrafını çekin!",
            value: false,
          },
          {
            text: "İsterseniz bebek odasını hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Bir profesyonel tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Sigara içenlerin yanında olmaktan kaçının.",
            value: false,
          },
          {
            text: "Ayaklarınız şişmiş ve boyutu artmışsa yeni ayakkabılar alın.",
            value: false,
          },
          {
            text: "Tekmelediğini hissettiğinizde bebeğinizle konuşun.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Stresten kaçının ve günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Her gün karnınıza iyi bir krem ​​sürün.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Göğüsleriniz daha büyük olacak, bu nedenle destekleyici bir sütyen takmayı düşünün.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bir doğum sınıfına kaydolun.",
            value: false,
          },
          {
            text: "İkinci üç aylık dönemdeki hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinize ve bebek doğduktan sonra nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninizi planlamaya başlayın - ne kadar hakkınız olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 20,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Kısa bir merdiven çıktıktan sonra nefessiz hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Şimdiye kadar bebeğinizin tekmelemesini hissedebilmelisiniz.",
            value: false,
          },
          {
            text: "Ayaklarınızda ve ayak bileklerinizde şişme (ödem) olabilir.",
            value: false,
          },
          {
            text: "Göbek deliğiniz dışarı fırlamış olabilir.",
            value: false,
          },
          {
            text: "Geceleri bacak kramplarınız olabilir.",
            value: false,
          },
          {
            text: "Başınız dönebilir.",
            value: false,
          },
          {
            text: "Baş ağrısı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Mide ekşimesi, hazımsızlık ve / veya kabızlık yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Karnınızda, kasıklarınızda ve / veya kolunuzda ağrı olabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için kırmızı et, kümes hayvanları, balık, mercimek, yeşil yapraklı sebzeler ve tam tahıllar gibi demir açısından zengin besinler tüketin.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Ayrıntılı fetal anomali taraması (19.Hafta ile 22. Hafta Arasında) - fetustaki yapısal anormallikleri ve plasental pozisyon gibi diğer ayrıntıları kontrol etmek için",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Amniyosentez (16. Hafta ile 20. Hafta Arasında) - kromozom anormalliklerini, nöral tüp kusurlarını ve genetik bozuklukları tespit eder.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "35 yaşın üzerindeyseniz, amniyosentez testi yaptırmayı sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Eşinizi de ultrason testi için yanınızda getirin.",
            value: false,
          },
          {
            text: "Şimdi seyahat etme zamanı! (Ama önce doktorunuza danışın)",
            value: false,
          },
          {
            text: "Bebeğinizin geleceği için bir tasarruf hesabı açın.",
            value: false,
          },
          {
            text: "Ağır şeyleri kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Vücudunuzun etrafındaki kan akışını kısıtlayabileceği için sırt üstü yatmayın. Yanınızda uyuyun (tercihen sol tarafta).",
            value: false,
          },
          {
            text: "Kendinizi çok fazla zorlamayın; vücudunuzu dinleyin!",
            value: false,
          },
          {
            text: "Kimyasal ve koruyucu içermeyen güvenli kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın bir fotoğrafını çekin!",
            value: false,
          },
          {
            text: "İsterseniz bebek odasını hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Bir profesyonel tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Sigara içenlerin yanında olmaktan kaçının.",
            value: false,
          },
          {
            text: "Ayaklarınız şişmiş ve boyutu artmışsa yeni ayakkabılar alın.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Stresten kaçının ve günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Karnınıza iyi bir krem ​​sürün.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak ve rahatlatıcı, sakinleştirici müzik çalarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Doğum öncesi balayına git!",
            value: false,
          },
          {
            text: "Göğüsleriniz daha büyük olacak, bu nedenle destekleyici bir sütyen takmayı düşünün.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bir doğum sınıfına kaydolun.",
            value: false,
          },
          {
            text: "İkinci üç aylık dönemdeki hamilelik dostu egzersiz hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Eşinizin hamileliğinize ve bebek doğduktan sonra nasıl daha fazla dahil olabileceğini öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninizi planlamaya başlayın - ne kadar hakkınız olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 21,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Karnınızda, göğsünüzde ve hatta kollarınızda çatlaklar fark edebilirsiniz.",
            value: false,
          },
          {
            text: "Gerilmiş cilt nedeniyle karnınızda kaşıntı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Ayaklarınızda ve ayak bileklerinizde şişme (ödem) olabilir.",
            value: false,
          },
          {
            text: "Sivilceniz olabilir.",
            value: false,
          },
          {
            text: "Bacaklarınızda varisli damarlara dönüşebilen mavimsi damarlar oluşabilir.",
            value: false,
          },
          {
            text: "Geceleri bacak kramplarınız olabilir.",
            value: false,
          },
          {
            text: "Karın, kasık ve / veya kalçanızda ağrı olabilir.",
            value: false,
          },
          {
            text: "Her zamankinden daha titrek ve sakar hissetmeye başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Şişmiş ve kanayan diş etleriniz olabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için kırmızı et, kümes hayvanları, balık, mercimek, yeşil yapraklı sebzeler ve tam tahıllar gibi demir açısından zengin besinler tüketin.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Ayrıntılı fetal anomali taraması (19.Hafta ile 22. Hafta Arasında) - fetustaki yapısal anormallikleri ve plasental pozisyon gibi diğer ayrıntıları kontrol etmek için",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Hamilelik kurslarına gitmeye başlayın - eşinizi yanınızda getirin.",
            value: false,
          },
          {
            text: "Şişmişlerse rahatlama için ayaklarınızı ve ayak bileklerinizi kaldırın.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle konuşmaya teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Vücudunuzun etrafındaki kan akışını kısıtlayabileceği için sırt üstü yatmayın. Yanınızda uyuyun (tercihen sol tarafta).",
            value: false,
          },
          {
            text: "Ağır şeyleri kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Çok yorulmayın; vücudunuzu dinleyin!",
            value: false,
          },
          {
            text: "Kimyasal ve koruyucu içermeyen güvenli kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın bir fotoğrafını çekin!",
            value: false,
          },
          {
            text: "İsterseniz bebek odasını hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Bir profesyonel tarafından hamilelik masajı yaptırmayı düşünün.",
            value: false,
          },
          {
            text: "Sigara içenlerin yanında olmaktan kaçının.",
            value: false,
          },
          {
            text: "Ayaklarınız şişmiş ve boyutu artmışsa yeni ayakkabılar alın.",
            value: false,
          },
          {
            text: "Dişlerinizi ve ağzınızı temiz ve sağlıklı tutun.",
            value: false,
          },
          {
            text: "Stresten kaçının ve günde en az 8 saat uyumaya çalışın.",
            value: false,
          },
          {
            text: "Karnınıza iyi bir krem ​​sürün.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak ve rahatlatıcı, sakinleştirici müzik çalarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Doğum öncesi balayına gidin!",
            value: false,
          },
          {
            text: "Göğüsleriniz daha büyük olacak, bu nedenle destekleyici bir sütyen takmayı düşünün.",
            value: false,
          },
          {
            text: "Bebek doğduğunda bunu yapacak vaktin olmayacağı için arkadaşlarınızla görüşün.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Özellikle doğumdan hemen sonra emzirme hakkında mümkün olduğunca çok şey öğrenin.",
            value: false,
          },
          {
            text: "Farklı doğum yöntemlerinin artılarını ve eksilerini okuyun.",
            value: false,
          },
          {
            text: "Farklı solunum teknikleri gibi doğum ağrısını hafifletmenin yollarını öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninizi planlayın.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
          {
            text: "Doğum iznine çıkmadan önce yapılacaklar listenizi hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Doğum izninden sonra işe dönecekseniz, bir bakıcı veya bebek bakım merkezi aramaya başlamanın tam zamanı.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 22,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Büyüyen rahminiz kaburgalarınıza baskı yapabilir ve bu da solunum güçlüğüne neden olabilir.",
            value: false,
          },
          {
            text: "Artık karnınızda bir bebek yumrunuz var!",
            value: false,
          },
          {
            text: "Göbek deliğiniz dışarı çıkabilir.",
            value: false,
          },
          {
            text: "Hamilelik hormonları sayesinde kalın, parlak saçlara sahip olabilirsiniz.",
            value: false,
          },
          {
            text: "Kabızlık, mide ekşimesi ve / veya hazımsızlık yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Uykunuzu bacak krampları ile kesintiye uğratabilirsiniz.",
            value: false,
          },
          {
            text: "Baş dönmesi veya sersemlik hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Karnınızda, kalçalarınızda, uyluklarınızda ve göğüslerinizde çatlaklar görünmeye başlamış olabilir.",
            value: false,
          },
          {
            text: "Ayaklarınızda ve ayak bileklerinizde şişme (ödem) olabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için kırmızı et, kümes hayvanları, balık, mercimek, yeşil yapraklı sebzeler ve tam tahıllar gibi demir açısından zengin besinler tüketin.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Ayrıntılı fetal anomali taraması (19.Hafta ile 22. Hafta Arasında) - fetustaki yapısal anormallikleri ve plasental pozisyon gibi diğer ayrıntıları kontrol etmek için",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Hamileliğiniz sırasında en az bir kez diş hekimine gidin.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Duruşunuzu kontrol edin - gerekirse sırtınızı desteklemek için bir yastık kullanın.",
            value: false,
          },
          {
            text: "Rahat ayakkabılar giyin.",
            value: false,
          },
          {
            text: "Çok çalışmayın ve stresten kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sınıfına katılın.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Vücudunuzun etrafındaki kan akışını kısıtlayabileceği için sırt üstü yatmayın. Yanınızda uyuyun, tercihen solunuzda.",
            value: false,
          },
          {
            text: "Bebek partiniz hakkında fikirleriniz varsa, bunları planlayan arkadaşlarınızla paylaşın.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi yormayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Göğüsleriniz daha büyük olacak, bu yüzden destekleyici bir sütyen takmayı düşünün.",
            value: false,
          },
          {
            text: "Doğum öncesi balayına gidin! Ama seyahat ederken kendinizi çok fazla yormayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Emzirmeyi planlıyorsanız, kaydolabileceğiniz iyi bir emzirme danışmanı veya emzirme sınıfları bulun.",
            value: false,
          },
          {
            text: "Farklı doğum yöntemlerinin artılarını ve eksilerini okuyun.",
            value: false,
          },
          {
            text: "Bir veya daha fazla hamilelik ve ebeveyn grubuna çevrimiçi olarak katılın.",
            value: false,
          },
          {
            text: "Bebek odası tasarımlarını araştırın.",
            value: false,
          },
          {
            text: "Bebek karyolası ve beşiklerle ilgili bilgileri arayın.",
            value: false,
          },
          {
            text: "Farklı solunum teknikleri gibi doğum ağrısını hafifletmenin yollarını öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninizi amiriniz ve yakın meslektaşlarınızla planlayın.",
            value: false,
          },
          {
            text: "Yokluğunda sizi kimin karşılayacağını bulun.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
          {
            text: "Doğum iznine çıkmadan önce yapılacaklar listenizi hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Doğum izninden sonra işe dönecekseniz, bir bakıcı veya bebek bakım merkezi aramaya başlamanın tam zamanı.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 23,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Gebelik hormonlarının yükselmesi nedeniyle horlama ve burun tıkanıklığı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Vücut ağırlığınız yaklaşık 5,4 - 6,8 kg arttı.",
            value: false,
          },
          {
            text: "Daha sık idrara çıkmak isteyeceksiniz.",
            value: false,
          },
          {
            text: "Diş etleriniz ve / veya burnunuz artan kan akışı nedeniyle kanayabilir.",
            value: false,
          },
          {
            text: "Bu günlerde daha aç hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Ayaklarınızda ve ayak bileklerinizde şişme (ödem) olabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Anemiyi önlemek için kırmızı et, kümes hayvanları, balık, mercimek, yeşil yapraklı sebzeler ve tam tahıllar gibi demir açısından zengin besinler tüketin.",
            value: false,
          },
          {
            text: "Bebeğin hızla gelişen kemik ve dişlerine yardımcı olduğu için kalsiyum, D vitamini ve magnezyum yönünden zengin besinler yiyin.",
            value: false,
          },
          {
            text: "Minimum su tutma oranına sahip olmak için daha az tuz tüketin.",
            value: false,
          },
          {
            text: "Şeker alımınıza dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Hamileliğiniz sırasında en az bir kez diş hekimine gidin.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Endişelerinizi hafifletmek için eşinizle paylaşın.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda el dezenfektanı taşıyın.",
            value: false,
          },
          {
            text: "Çok çalışmayın ve stresten kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sınıfına katılın.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Vücudunuzun etrafındaki kan akışını kısıtlayabileceği için sırt üstü yatmayın. Yanınızda uyuyun, tercihen solunuzda.",
            value: false,
          },
          {
            text: "Bebek partiniz hakkında fikirleriniz varsa, bunları planlayan arkadaşlarınızla paylaşın.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi yormayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Göğüsleriniz daha büyük olacak, bu yüzden destekleyici bir sütyen takmayı düşünün.",
            value: false,
          },
          {
            text: "Doğum öncesi balayına gidin! Ama seyahat ederken kendinizi çok fazla yormayın.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Yürüme ve yoga gibi güvenli ve nazik egzersizler yapmaya devam edin.",
            value: false,
          },
          {
            text: "Pelvik tabanınızı güçlendirmek ve doğum sancılarına yardımcı olmak için Kegel egzersizleri yapın.",
            value: false,
          },
          {
            text: "Tek bir yerde uzun süre oturuyorsanız, bacaklarınızı ve kollarınızı hafifçe esnetin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Emzirmeyi planlıyorsanız, kaydolabileceğiniz iyi bir emzirme danışmanı veya emzirme sınıfları bulun.",
            value: false,
          },
          {
            text: "Farklı doğum yöntemlerinin artılarını ve eksilerini okuyun.",
            value: false,
          },
          {
            text: "Dilerseniz suda doğum veya hipno-doğum gibi alternatif doğum yöntemlerini araştırmaya başlayın.",
            value: false,
          },
          {
            text: "Bebek odası veya çocuk odası tasarımları arayın.",
            value: false,
          },
          {
            text: "Bir veya daha fazla hamilelik, emzirme ve ebeveynlik grubuna çevrimiçi olarak katılın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninizi amiriniz ve yakın meslektaşlarınızla planlayın.",
            value: false,
          },
          {
            text: "Yokluğunda sizi kimin karşılayacağını bulun.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
          {
            text: "Doğum iznine çıkmadan önce yapılacaklar listenizi hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Doğum izninden sonra işe dönecekseniz, bir bakıcı veya bebek bakım merkezi aramaya başlamanın tam zamanı.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 24,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Ayaklarınızda ve ayak bileklerinizde şişme (ödem) olabilir.",
            value: false,
          },
          {
            text: "Şimdiye kadar 7-8 kg kazanmış olabilirsiniz.",
            value: false,
          },
          {
            text: "Göğüslerinizde ve karnınızda çatlaklar görebilirsiniz.",
            value: false,
          },
          {
            text: "Linea nigra - göbek deliğinizden kasık kemiğinize kadar uzanan siyah bir çizgi - görünecektir.",
            value: false,
          },
          {
            text: "Hamilelik hormonlarına bağlı olarak migren ve / veya bulanık görme yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Uykunuzu bacak krampları ile kesintiye uğratabilirsiniz.",
            value: false,
          },
          {
            text: "Bileklerinizde ve parmaklarınızda rahatsız edici bir karıncalanma, uyuşma veya ağrı hissedebilirsiniz (karpal tünel sendromu).",
            value: false,
          },
          {
            text: "Kabızlık, mide ekşimesi ve / veya hazımsızlık yaşıyor olabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Kalsiyum artışı için diyetinize az yağlı süt ürünleri ekleyin.",
            value: false,
          },
          {
            text: "C vitamini açısından zengin besinler ve yeşil yapraklı sebzeler tüketin.",
            value: false,
          },
          {
            text: "Reflüye neden olabilecek çok asitli gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Dengeli bir diyetle taze meyve, sebze, yağsız et ve balık tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Sigara dumanı ve alkolden kaçının.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Oral Glikoz Tolerans Testi (GTT) (24. Hafta ile 28. Hafta Arası) - annede gebelik diyabeti taraması için. 3 kan testi içerir.",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Olağandışı semptomlara dikkat edin ve varsa derhal doktora bildirin.",
            value: false,
          },
          {
            text: "Diş eti kanaması veya enfeksiyon kapma riskini azaltmak için iyi bir diş hijyeni sağlayın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Göbek bağınızın sağlıklı ve normal olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Endişelerinizi hafifletmek için endişelerinizi eşinizle paylaşın.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda el dezenfektanı taşıyın.",
            value: false,
          },
          {
            text: "Çok çalışmayın ve stresten kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sınıfına katılın.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Vücudunuzun etrafındaki kan akışını kısıtlayabileceği için sırt üstü yatmayın. Yanınızda uyuyun, tercihen solunuzda.",
            value: false,
          },
          {
            text: "Bebek partiniz hakkında fikirleriniz varsa, bunları planlayan arkadaşlarınızla paylaşın.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi yormayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Göğüsleriniz daha büyük olacak, bu yüzden destekleyici bir sütyen takmayı düşünün.",
            value: false,
          },
          {
            text: "Bebek öncesi balayına gidin! Ama seyahat ederken kendinizi çok fazla yormayın.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Yürüme ve yoga gibi güvenli ve nazik egzersizler yapmaya devam edin.",
            value: false,
          },
          {
            text: "Pelvik tabanınızı güçlendirmek ve doğum sancılarına yardımcı olmak için Kegel egzersizleri yapın.",
            value: false,
          },
          {
            text: "Tek bir yerde uzun süre oturuyorsanız, bacaklarınızı ve kollarınızı hafifçe esnetin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Emzirmeyi planlıyorsanız, kaydolabileceğiniz iyi bir emzirme danışmanı veya emzirme sınıfları bulun.",
            value: false,
          },
          {
            text: "Farklı doğum yöntemlerinin artılarını ve eksilerini okuyun.",
            value: false,
          },
          {
            text: "Dilerseniz suda doğum veya hipno-doğum gibi alternatif doğum yöntemlerini araştırmaya başlayın.",
            value: false,
          },
          {
            text: "Bebek odası veya çocuk odası tasarımları arayın.",
            value: false,
          },
          {
            text: "Bir veya daha fazla hamilelik, emzirme ve ebeveynlik grubuna çevrimiçi olarak katılın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninizi amiriniz ve yakın meslektaşlarınızla planlayın.",
            value: false,
          },
          {
            text: "Yokluğunda sizi kimin karşılayacağını bulun.",
            value: false,
          },
          {
            text: "Uzun süre tek bir yerde oturursanız, ara sıra hafif esnetmeyi unutmayın.",
            value: false,
          },
          {
            text: "Doğum iznine çıkmadan önce yapılacaklar listenizi hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Doğum izninden sonra işe dönecekseniz, bir dadı veya bebek bakım merkezi aramaya başlamanın tam zamanı.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 25,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Karnınız bir futbol topu büyüklüğünde!",
            value: false,
          },
          {
            text: "Bacaklarınız ve hatta beliniz gibi vücudunuzun her yerinde ağrı ve sızı yaşamaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Kabızlık yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Meme uçlarınız renk değiştirecek ve koyulaşacak.",
            value: false,
          },
          {
            text: "Mide ekşimesi ve hazımsızlık yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Gebelik hormonlarının yükselmesi nedeniyle horlama ve burun tıkanıklığı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Bileklerinizde ve parmaklarınızda rahatsız edici bir karıncalanma, uyuşma veya ağrı hissedebilirsiniz (karpal tünel sendromu).",
            value: false,
          },
          {
            text: "Braxton Hicks veya yalancı kasılmalar yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Lif bakımından zengin sebze, meyve ve diğer sağlıklı yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve konserve yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Her gün hafif egzersizler yapın - Hızlı bir yürüyüş veya hamilelik yogası harikadır.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi her gün yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Oral Glikoz Tolerans Testi (GTT) (24. Hafta ile 28. Hafta Arası) - annede gebelik diyabeti taraması için. 3 kan testi içerir.",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Olağandışı semptomlara dikkat edin ve varsa derhal doktora bildirin.",
            value: false,
          },
          {
            text: "Diş eti kanaması veya enfeksiyon kapma riskini azaltmak için iyi bir diş hijyeni sağlayın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Göbek bağınızın sağlıklı ve normal olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
          {
            text: "Diğer endişeleriniz hakkında doktorunuzla konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Ev işi yaparken ağartıcı veya diğer ürünleri sert kimyasallarla temizlemekten kaçının.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Sırt üstü uyumaktan kaçının.",
            value: false,
          },
          {
            text: "Bebek partiniz hakkında fikirleriniz varsa, bunları planlayan arkadaşlarınızla paylaşın.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi zorlamayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu sürmeyi unutmayın.",
            value: false,
          },
          {
            text: "Bebeğinizle şarkı söyleyerek veya konuşarak ya da rahatlatıcı, sakinleştirici müzik çalarak bebeğinizi canlandırmak için günde minimum 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Göğüsleriniz daha büyük olacak, bu yüzden destekleyici bir sütyen takmayı düşünün.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bebek isimlerini araştırın.",
            value: false,
          },
          {
            text: "Bir yardımcıya ihtiyaç duyacak mısınız? Buna dair süreci araştırmaya başlayın.",
            value: false,
          },
          {
            text: "Hem hamileliği, hem doğumu hem de ötesini kapsayacak sigorta planlarını araştırın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninden sonra işe döndüğünüzde bebeğinize kimin bakacağını düşünmeye başlayın.",
            value: false,
          },
          {
            text: "Ofisinizde bir emzirme odası veya döndüğünüzde süt sağabileceğiniz bir yer var mı? Değilse, bunun hakkında yetkililerle konuşun.",
            value: false,
          },
          {
            text: "Gerekirse doğum izninin uzatılmasıyla ilgili işyeri politikalarınızın neler olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Vücut ağırlığınız önemli ölçüde artar veya aşırı derecede şişkin hissederseniz, güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 26,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Bebeğin tekmelediğini ve çok hareket ettiğini hissedeceksiniz.",
            value: false,
          },
          {
            text: "Sırt ağrısı, mide ekşimesi ve bacak krampları nedeniyle uyumakta zorluk çekebilirsiniz.",
            value: false,
          },
          {
            text: "Vücudunuzun her yerinde ağrı ve sızılar yaşayacaksınız.",
            value: false,
          },
          {
            text: "Bacaklarınızda şiddetli kramplar yaşamaya başlayabilirsiniz.",
            value: false,
          },
          {
            text: "Bazı kadınlar gebelik hormonlarının neden olduğu bulanık görme yaşayabilir.",
            value: false,
          },
          {
            text: "Braxton Hicks veya yalancı kasılmalar yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Mide ekşimesi ve hazımsızlık yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Daha sıcak hissedebilir ve sıcak basması yaşayabilirsiniz.",
            value: false,
          },
          {
            text: 'Son zamanlarda daha unutkan mı hissediyorsunuz? "Hamilelik beyni" yaşıyor olabilirsiniz.',
            value: false,
          },
          {
            text: "Gevşemiş eklemler ve kilo alma nedeniyle sakar, güçsüz olabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Lif bakımından zengin sebze, meyve ve diğer sağlıklı yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve konserve yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Her gün hafif egzersizler yapın - Hızlı bir yürüyüş veya hamilelik yogası harikadır.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi her gün yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Oral Glikoz Tolerans Testi (GTT) (24. Hafta ile 28. Hafta Arası) - annede gebelik diyabeti taraması için. 3 kan testi içerir.",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Olağandışı semptomlara dikkat edin ve varsa derhal doktora bildirin.",
            value: false,
          },
          {
            text: "Diş eti kanaması veya enfeksiyon kapma riskini azaltmak için iyi bir diş hijyeni sağlayın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Göbek bağınızın sağlıklı ve normal olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
          {
            text: "Diğer endişeleriniz hakkında doktorunuzla konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Muhteşem hamilelik fotoğraflarını çekin.",
            value: false,
          },
          {
            text: "Doğum için tercih ettiğiniz hastaneye karar verin - Evinizden çok uzakta olmamalıdır.",
            value: false,
          },
          {
            text: "Sabah ve gece bebeğin tekme ve hareketlerini sayın (Bütün gün hareket yoksa doktorunuza görünün).",
            value: false,
          },
          {
            text: "Ev işi yaparken ağır kimyasallarla temizlemekten kaçının.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Kan dolaşımını kısıtlayabileceğinden sırt üstü uyumaktan kaçının.",
            value: false,
          },
          {
            text: "Bebek partiniz hakkında fikirleriniz varsa, bunları planlayan arkadaşlarınızla paylaşın.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi yormayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bebek isimlerini araştırın.",
            value: false,
          },
          {
            text: "Bir yardımcıya ihtiyaç duyacak mısınız? Buna dair süreci araştırmaya başlayın.",
            value: false,
          },
          {
            text: "Hem hamileliği, hem doğumu hem de ötesini kapsayacak sigorta planlarını araştırın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninden sonra işe döndüğünüzde bebeğinize kimin bakacağını düşünmeye başlayın.",
            value: false,
          },
          {
            text: "Ofisinizde bir emzirme odası veya döndüğünüzde süt sağabileceğiniz bir yer var mı? Değilse, bunun hakkında yetkililerle konuşun.",
            value: false,
          },
          {
            text: "Gerekirse doğum izninin uzatılmasıyla ilgili şirket politikalarınızın neler olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Vücut ağırlığınız önemli ölçüde artar veya aşırı derecede şişkin hissederseniz, güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 27,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Braxton-Hicks kasılmalarını hissetmeye başlayabilirsiniz (bu olduğunda rahminiz gergin veya sıkışmış hisseder).",
            value: false,
          },
          {
            text: "Vücutta sıvı birikmesi nedeniyle bilekleriniz, ayaklarınız ve elleriniz hafifçe şişebilir.",
            value: false,
          },
          {
            text: "Diş eti kanaması yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Bebeğinizin tekmelerini ve hareketlerini hissedecek ve hatta göreceksiniz.",
            value: false,
          },
          {
            text: "Bacaklarınız gerginleşebilir ve biraz karıncalanabilir - buna huzursuz bacak sendromu denir.",
            value: false,
          },
          {
            text: "Baygınlık veya baş dönmesi hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Gerilmiş karnınız cildinizin kuru ve kaşınmasına neden olabilir.",
            value: false,
          },
          {
            text: "Genişleyen rahminizin neden olduğu yuvarlak bağ ağrısı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Yüksek gebelik hormonları nedeniyle burun tıkanıklığı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Rahim büyüdükçe, göğsünüzün üst kısmına baskı uygular ve nefessiz hissedebilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Lif bakımından zengin sebze, meyve ve diğer sağlıklı yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve konserve yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Her gün hafif egzersizler yapın - Hızlı bir yürüyüş veya hamilelik yogası harikadır.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi her gün yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Oral Glikoz Tolerans Testi (GTT) (24. Hafta ile 28. Hafta Arası) - annede gebelik diyabeti taraması için. 3 kan testi içerir.",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Olağandışı semptomlara dikkat edin ve varsa derhal doktora bildirin.",
            value: false,
          },
          {
            text: "Diş eti kanaması veya enfeksiyon kapma riskini azaltmak için iyi bir diş hijyeni sağlayın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Göbek bağınızın sağlıklı ve normal olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
          {
            text: "Diğer endişeleriniz hakkında doktorunuzla konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Muhteşem hamilelik fotoğraflarını çekin.",
            value: false,
          },
          {
            text: "Doğum için tercih ettiğiniz hastaneye karar verin - Evinizden çok uzakta olmamalıdır.",
            value: false,
          },
          {
            text: "Sabah ve gece bebeğin tekme ve hareketlerini sayın (Bütün gün hareket yoksa doktorunuza görünün).",
            value: false,
          },
          {
            text: "Ev işi yaparken ağır kimyasallarla temizlemekten kaçının.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Kan dolaşımını kısıtlayabileceğinden sırt üstü uyumaktan kaçının.",
            value: false,
          },
          {
            text: "Bebek partiniz hakkında fikirleriniz varsa, bunları planlayan arkadaşlarınızla paylaşın.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi yormayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Kordon kanı ile ilgili bilgi alıp, kararınızı verin.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimi hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Çevrimiçi bir anne topluluğu arayın ve katılın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninden sonra işe döndüğünüzde bebeğinize kimin bakacağını düşünmeye başlayın.",
            value: false,
          },
          {
            text: "Ofisinizde bir emzirme odası veya döndüğünüzde süt sağabileceğiniz bir yer var mı? Değilse, bunun hakkında yetkililerle konuşun.",
            value: false,
          },
          {
            text: "Gerekirse doğum izninin uzatılmasıyla ilgili şirket politikalarınızın neler olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Vücut ağırlığınız önemli ölçüde artar veya aşırı derecede şişkin hissederseniz, güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 28,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Hala diş etlerinde iltihaplanma, şişme veya kanama yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Bacak krampları yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Hemoroit olabilirsiniz.",
            value: false,
          },
          {
            text: "Büyük karnın ve bebeğin tekmeleriyle uykuya dalmak zor olabilir.",
            value: false,
          },
          {
            text: "Kolondaki basınç arttıkça kabızlık daha sık olacaktır.",
            value: false,
          },
          {
            text: "Doğum konusunda endişe yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Meme uçlarınız daha büyük ve daha koyu olacak.",
            value: false,
          },
          {
            text: "Göbek deliğinizden kasık kemiğinize kadar uzanan koyu renkli bir çizginiz olabilir: Linea nigra.",
            value: false,
          },
          {
            text: "Gerilmiş karnınız cildinizin kuru ve kaşınmasına neden olabilir.",
            value: false,
          },
          {
            text: "Son derece yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Şişkinlik ve gaz yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Burnunuz tıkalı olabilir.",
            value: false,
          },
          {
            text: "Bazen nefessiz hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Braxton Hicks veya yalancı kasılmalar yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Pelvik bölgenizde ve belinizde ağrı olabilir.",
            value: false,
          },
          {
            text: "Sık idrara çıkma yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Lif bakımından zengin sebze, meyve ve diğer sağlıklı yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve konserve yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Her gün hafif egzersizler yapın - Hızlı bir yürüyüş veya hamilelik yogası harikadır.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi her gün yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Oral Glikoz Tolerans Testi (GTT) (24. Hafta ile 28. Hafta Arası) - annede gebelik diyabeti taraması için. 3 kan testi içerir.",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Olağandışı semptomlara dikkat edin ve varsa derhal doktora bildirin.",
            value: false,
          },
          {
            text: "Diş eti kanaması veya enfeksiyon kapma riskini azaltmak için iyi bir diş hijyeni sağlayın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "3B veya 4B tarama hakkında soru sorun.",
            value: false,
          },
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
          {
            text: "Diğer endişeleriniz hakkında doktorunuzla konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Her gün yeterince dinlenin ve gerekirse kestirin.",
            value: false,
          },
          {
            text: "Hamilelik için fotoğraf çekimi yapın.",
            value: false,
          },
          {
            text: "Bebeğiniz için alışverişe başlayın - bebeğiniz hızla büyüyeceği için çok fazla yenidoğan kıyafeti almayın.",
            value: false,
          },
          {
            text: "Bebeğiniz için bir isim belirleyin veya bir liste hazırlayın.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Kan dolaşımını kısıtlayabileceğinden sırt üstü uyumaktan kaçının. ",
            value: false,
          },
          {
            text: "Bebek partiniz hakkında fikirleriniz varsa, bunları planlayan arkadaşlarınızla paylaşın.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi yormayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıktığınızda yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu sürmeyi unutmayın.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bebeğinizin kordon kanını saklama hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Bir doğum veya emzirme kursuna kaydolun.",
            value: false,
          },
          {
            text: "Yakında işe geri dönmeniz gerekiyorsa çocuk bakımı seçeneklerini araştırın.",
            value: false,
          },
          {
            text: "Bebek oto koltuğu üzerine araştırma yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum izninden sonra işe döndüğünüzde bebeğinize kimin bakacağını düşünmeye başlayın.",
            value: false,
          },
          {
            text: "Ofisinizde bir emzirme odası veya döndüğünüzde süt sağabileceğiniz bir yer var mı? Değilse, bunun hakkında yetkililerle konuşun.",
            value: false,
          },
          {
            text: "Gerekirse doğum izninin uzatılmasıyla ilgili şirket politikalarınızın neler olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın Eğer ...",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Vücut ağırlığınız önemli ölçüde artar veya aşırı derecede şişkin hissederseniz, güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 29,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Bebeğiniz güçlü bir şekilde tekmeleyebilir ve yumruklayabilir.",
            value: false,
          },
          {
            text: "Az önce yemiş olsanız bile çok çabuk acıkabilirsiniz.",
            value: false,
          },
          {
            text: "Kızarıklıklar, kuru cilt ve yoğun kaşıntı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Ruh hali değişimleri yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Kabızlık ve hemoroid hastalığınız olabilir.",
            value: false,
          },
          {
            text: "Bacaklarınızda şişkin ve muhtemelen kaşıntılı mavi damarlar olan varisli damarlarınız olabilir.",
            value: false,
          },
          {
            text: "Bacak krampları yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Genişleyen rahim ciğerlerinize baskı uyguladığından nefes almakta zorluk çekebilirsiniz.",
            value: false,
          },
          {
            text: "Ayak bileklerinizde, ayaklarınızda ve ellerinizde ödem olarak bilinen hafif bir şişlik görebilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Kırmızı kan hücresi üretimini artırmaya yardımcı olmak için demir açısından zengin yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Lif bakımından zengin sebze, meyve ve diğer sağlıklı yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve konserve yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Her gün hafif egzersizler yapın - Hızlı bir yürüyüş veya hamilelik yogası harikadır.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi her gün yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Oral Glikoz Tolerans Testi (GTT) (24. Hafta ile 28. Hafta Arası) - annede gebelik diyabeti taraması için. 3 kan testi içerir.",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Olağandışı semptomlara dikkat edin ve varsa derhal doktora bildirin.",
            value: false,
          },
          {
            text: "Diş eti kanaması veya enfeksiyon kapma riskini azaltmak için iyi bir diş hijyeni sağlayın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "3B veya 4B tarama hakkında soru sorun.",
            value: false,
          },
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
          {
            text: "Varisli damarlarınız varsa, bunları nasıl yöneteceğiniz konusunda doktorunuzla konuşun.",
            value: false,
          },
          {
            text: "Diğer endişeleriniz hakkında doktorunuzla konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Kaşıntı hissederseniz cildinizi kaşımaktan kaçının; bunun yerine iyi bir nemlendirici uygulayın.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Her gün yeterince dinlenin ve gerekirse kestirin.",
            value: false,
          },
          {
            text: "Hamilelik için fotoğraf çekimi yapın.",
            value: false,
          },
          {
            text: "Bebeğiniz için alışverişe başlayın - bebeğiniz hızla büyüyeceği için çok fazla yeni doğan kıyafeti almayın.",
            value: false,
          },
          {
            text: "Bebeğiniz için bir isim belirleyin veya bir liste hazırlayın.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Kan dolaşımını kısıtlayabileceğinden sırt üstü uyumaktan kaçının. ",
            value: false,
          },
          {
            text: "Bebek partiniz hakkında fikirleriniz varsa, bunları planlayan arkadaşlarınızla paylaşın.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi yormayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıktığınızda yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu sürmeyi unutmayın.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Doğum sonrası masaj tedavilerini araştırmaya başlayın.",
            value: false,
          },
          {
            text: "Bir doğum veya emzirme kursuna kaydolun.",
            value: false,
          },
          {
            text: "Yakında işe geri dönmeniz gerekiyorsa çocuk bakımı seçeneklerini araştırın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Hamilelik size unutturabileceğinden günlük görevlerinizi not edin.",
            value: false,
          },
          {
            text: "Ofisinizde bir emzirme odası veya döndüğünüzde süt sağabileceğiniz bir yer var mı? Değilse, bunun hakkında yetkililerle konuşun.",
            value: false,
          },
          {
            text: "Gerekirse doğum izninin uzatılmasıyla ilgili işyeri politikalarınızın neler olduğunu öğrenin.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 30,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Mide ekşimesi yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Bebeğiniz hareket ederken ve tekmelerken midenizin hareket ettiğini ve dalgalandığını göreceksiniz.",
            value: false,
          },
          {
            text: "Ruh hali değişimleri ve yorgunluk yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Eklemleriniz gerilirken dengeniz bozulabilir.",
            value: false,
          },
          {
            text: "Bağ gevşemeniz ayaklarınızın kalıcı olarak genişlemesine ve bir boyut yükselmesine neden olabilir.",
            value: false,
          },
          {
            text: "Bel ağrısı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Çatlaklar yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Şişkinlik, gaz ve / veya kabızlık çekiyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Sık idrara çıkma yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Nefes almakta güçlük çekebilirsiniz.",
            value: false,
          },
          {
            text: "Braxton Hicks kasılmaları yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Kırmızı kan hücresi üretimini artırmaya yardımcı olmak için demir açısından zengin yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Lif bakımından zengin sebze, meyve ve diğer sağlıklı yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve konserve yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Her gün hafif egzersizler yapın - Hızlı bir yürüyüş veya hamilelik yogası harikadır.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi her gün yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Oral Glikoz Tolerans Testi (GTT) (24. Hafta ile 28. Hafta Arası) - annede gebelik diyabeti taraması için. 3 kan testi içerir.",
            value: false,
          },
          {
            text: "Doğum uzmanıyla düzenli randevularınızı kaçırmayın.",
            value: false,
          },
          {
            text: "Olağandışı semptomlara dikkat edin ve varsa derhal doktora bildirin.",
            value: false,
          },
          {
            text: "Diş eti kanaması veya enfeksiyon kapma riskini azaltmak için iyi bir diş hijyeni sağlayın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "3B veya 4B tarama hakkında soru sorun.",
            value: false,
          },
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
          {
            text: "Varisli damarlarınız varsa, bunları nasıl yöneteceğiniz konusunda doktorunuzla konuşun.",
            value: false,
          },
          {
            text: "Diğer endişeleriniz hakkında doktorunuzla konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Kaşıntı hissederseniz cildinizi kaşımaktan kaçının; bunun yerine iyi bir nemlendirici uygulayın.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Her gün yeterince dinlenin ve gerekirse kestirin.",
            value: false,
          },
          {
            text: "Hamilelik için fotoğraf çekimi yapın.",
            value: false,
          },
          {
            text: "Bebeğiniz için alışverişe başlayın - bebeğiniz hızla büyüyeceği için çok fazla yeni doğan kıyafeti almayın.",
            value: false,
          },
          {
            text: "Bebeğiniz için bir isim belirleyin veya bir liste hazırlayın.",
            value: false,
          },
          {
            text: "Eşinizi bebeğinizle etkileşime girmeye teşvik edin.",
            value: false,
          },
          {
            text: "Rahatlamanıza yardımcı olacak yatıştırıcı müzik dinleyin.",
            value: false,
          },
          {
            text: "Kan dolaşımını kısıtlayabileceğinden sırt üstü uyumaktan kaçının. ",
            value: false,
          },
          {
            text: "Bebek partiniz için bir tarih belirleyin.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Egzersiz yapmaya devam edin ama kendinizi yormayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Büyüyen karnınızın resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıktığınızda yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu sürmeyi unutmayın.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Doğum sonrası masaj tedavilerini araştırmaya başlayın.",
            value: false,
          },
          {
            text: "Seçtiğiniz doğum yöntemini okuyun ve hazırlıklı olun.",
            value: false,
          },
          {
            text: "Doğum planı yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum iznine çıkmadan önce tamamlamanız gereken tüm evrakları doldurun.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Hamilelik size unutturabileceğinden günlük görevlerinizi not edin.",
            value: false,
          },
          {
            text: "Sağlıklı atıştırmalıklar getirin ve masanızda bir şişe su bulundurun.",
            value: false,
          },
          {
            text: "Yakında işe dönmeniz gerekiyorsa ve bir yardımcınız veya bebeğinize bakacak kimse yoksa, günlük bakım seçeneklerini araştırmaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 31,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Sık sık idrara çıkmanız gerekecek çünkü rahminiz mesanenizi ağır bir şekilde aşağı bastırıyor.",
            value: false,
          },
          {
            text: "Baş ağrısı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: 'Unutkan olduğunuz yerde "hamilelik beyni" yaşayabilirsiniz (Endişelenmeyin, doğum yaptıktan sonra her şey normale dönecektir).',
            value: false,
          },
          {
            text: "Yumuşatıcı bağlarınız sizi hantal yapabilir, bu yüzden adımlarınıza dikkat edin!",
            value: false,
          },
          {
            text: "Sırt ağrınız olabilir.",
            value: false,
          },
          {
            text: "Nefes almakta güçlük çekebilirsiniz.",
            value: false,
          },
          {
            text: "Uyumakta sorun yaşıyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Karnınızda, göğüslerinizde ve / veya kalçanızda kaşıntı yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Kırmızı kan hücresi üretimini artırmaya yardımcı olmak için demir açısından zengin yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Lif bakımından zengin sebze, meyve ve diğer sağlıklı yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve konserve yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Her gün hafif egzersizler yapın - Hızlı bir yürüyüş veya hamilelik yogası harikadır.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi her gün yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Alışılmadık şekilde üzgün, endişeli veya depresyonda hissediyorsanız, doktorunuza danışın.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
          {
            text: "Varisli damarlarınız varsa, bunları nasıl yöneteceğiniz konusunda doktorunuzla konuşun.",
            value: false,
          },
          {
            text: "Yalancı ve gerçek doğum sancıları arasındaki farkı sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Düz olmayan yüzeylerde kaygan yolda yürürken dikkatli olun.",
            value: false,
          },
          {
            text: "Düşmeleri önlemek için duş alanınıza kaymaz bir mat yerleştirin.",
            value: false,
          },
          {
            text: "Doğum çantanızı toplamaya başlayın.",
            value: false,
          },
          {
            text: "Cildinizi kaşındığında kaşımak yerine bir nemlendirici sürün.",
            value: false,
          },
          {
            text: "Kan dolaşımını iyileştirmek için sol tarafınızda uyuyun.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Çocuğunuzun geleceği için para biriktirmeye ve yatırım yapmaya başlayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Emzirme veya doğum hazırlık kurslarını atlamayın.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu sürmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hastane Çantanıza Neler Yerleştirmelisiniz",
        checklists: [
          {
            text: "Banyo malzemeleri, terlik ve çoraplar, makyaj ürünleri, diş fırçası, nemlendirici, dudak kremi, deodorant, saç bantları vb. kişisel ekipmanlar",
            value: false,
          },
          {
            text: "Doğum planınız",
            value: false,
          },
          {
            text: "Süt sağmanız gerektiğinde göğüs pompası",
            value: false,
          },
          {
            text: "En az 3 set yenidoğan kıyafeti - Karmaşık kıyafetlerden kaçının, kolları ve bacakları kaplayan pamuklu tulumlar en iyisidir.",
            value: false,
          },
          {
            text: "Rahat yastıklar, en sevdiğiniz şarkılardan oluşan bir çalma listesi, atıştırmalıklar vb. gibi rahatlamanıza yardımcı olacak öğeler",
            value: false,
          },
          {
            text: "Bol, rahat kıyafetler",
            value: false,
          },
          {
            text: "Kimlik kartları, sigorta belgeleri vb. gibi önemli belgeler",
            value: false,
          },
          {
            text: "Telefon ve telefon şarj cihazı",
            value: false,
          },
          {
            text: "Bebek için eve gidiş kıyafeti (çoraplar veya patikler ve battaniyesi dahil)",
            value: false,
          },
          {
            text: "Anne için hijyenik pedler",
            value: false,
          },
          {
            text: "Bebek bezi",
            value: false,
          },
          {
            text: "Islak mendiller, yumuşak bir bebek yıkama ve diğer bebek malzemeleri",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Bebeğinizin gelişimi hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Yenidoğan bakımı ve kendi bakımınız hakkında araştırma yapın.",
            value: false,
          },
          {
            text: "Seçtiğiniz doğum yöntemini okuyun ve hazırlıklı olun.",
            value: false,
          },
          {
            text: "Erken doğum belirtilerini araştırın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum iznine çıkmadan önce tamamlamanız gereken tüm evrakları doldurun.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Hamilelik size unutturabileceğinden günlük görevlerinizi not edin.",
            value: false,
          },
          {
            text: "Sağlıklı atıştırmalıklar getirin ve masanızda bir şişe su bulundurun.",
            value: false,
          },
          {
            text: "Yakında işe dönmeniz gerekiyorsa ve bir yardımcınız veya bebeğinize bakacak kimse yoksa, günlük bakım seçeneklerini araştırmaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 32,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Braxton Hicks`e veya sahte kasılmalara hazırlıklı olmalısınız.",
            value: false,
          },
          {
            text: "Meme uçlarınızdan çıkan berrak veya sarımsı sıvı damlalarını fark edebilirsiniz; bu kolostrumdur ve bebeğinizin ilk sütü olacak.",
            value: false,
          },
          {
            text: "Çatlaklarınız ve linea nigranız daha belirgindir.",
            value: false,
          },
          {
            text: "Çok daha yorgun hissetmeye başlayacaksınız.",
            value: false,
          },
          {
            text: "Ağrılı bacak krampları yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Kabızlık ve hemoroid hastalığınız olabilir.",
            value: false,
          },
          {
            text: "Genişleyen rahim ciğerlerinize baskı uyguladığından nefes almakta zorluk çekebilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Günde 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Lif bakımından zengin sebze, meyve ve diğer sağlıklı yiyecekler tüketin.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve konserve yiyeceklerden kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Kalsiyumun emilmesine yardımcı olmak için yeterli miktarda kalsiyum ve D vitamini aldığınızdan emin olun.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Doğum öncesi yoga sadece iyi bir egzersiz değildir, aynı zamanda vücut ağrılarını ve ağrılarını gidermeye de yardımcı olabilir.",
            value: false,
          },
          {
            text: "Kan dolaşımınızı iyileştirmek için bir süre yürüyün veya hafif egzersiz yapın.",
            value: false,
          },
          {
            text: "Kegel egzersizlerinizi her gün yapın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Alışılmadık şekilde üzgün, endişeli veya depresyonda hissediyorsanız, doktorunuza danışın.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Kaşıntılı cildi yatıştırmak için kalamin losyonu deneyin.",
            value: false,
          },
          {
            text: "Bebek partinizin zamanı!",
            value: false,
          },
          {
            text: "Doğum çantanızı toplamaya başlayın.",
            value: false,
          },
          {
            text: "Seçtiğiniz hastaneyi ziyaret edin ve tesislerini görün.",
            value: false,
          },
          {
            text: "Bebeğinizin odasını dekore etmeyi bitirin.",
            value: false,
          },
          {
            text: "Kan dolaşımını iyileştirmek için sol tarafınızda uyuyun.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Pedikür veya masajla kendinizi şımartın.",
            value: false,
          },
          {
            text: "Çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Çocuğunuzun geleceği için para biriktirmeye ve yatırım yapmaya başlayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Daha iyi uyku için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Kötü kimyasallar içermeyen güvenli kozmetikler kullanın.",
            value: false,
          },
          {
            text: "Emzirme veya doğum hazırlık kurslarını atlamayın.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu sürmeyi unutmayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hastane Çantanıza Neler Yerleştirmelisiniz",
        checklists: [
          {
            text: "Banyo malzemeleri, terlik ve çoraplar, makyaj ürünleri, diş fırçası, nemlendirici, dudak kremi, deodorant, saç bantları vb. kişisel ekipmanlar",
            value: false,
          },
          {
            text: "Doğum planınız",
            value: false,
          },
          {
            text: "Süt sağmanız gerektiğinde göğüs pompası",
            value: false,
          },
          {
            text: "En az 3 set yenidoğan kıyafeti - Karmaşık kıyafetlerden kaçının, kolları ve bacakları kaplayan pamuklu tulumlar en iyisidir.",
            value: false,
          },
          {
            text: "Rahat yastıklar, en sevdiğiniz şarkılardan oluşan bir çalma listesi, atıştırmalıklar vb. gibi rahatlamanıza yardımcı olacak öğeler",
            value: false,
          },
          {
            text: "Bol, rahat kıyafetler",
            value: false,
          },
          {
            text: "Kimlik kartları, sigorta belgeleri vb. gibi önemli belgeler",
            value: false,
          },
          {
            text: "Telefon ve telefon şarj cihazı",
            value: false,
          },
          {
            text: "Bebek için eve gidiş kıyafeti (çoraplar veya patikler ve battaniyesi dahil)",
            value: false,
          },
          {
            text: "Anne için hijyenik pedler",
            value: false,
          },
          {
            text: "Bebek bezi",
            value: false,
          },
          {
            text: "Islak mendiller, yumuşak bir bebek yıkama ve diğer bebek malzemeleri",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Farklı emzirme tutuşlarını araştırın ve bebeğinizi doğru şekilde nasıl tutacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Nefes alıp verme ve diğer tekniklerle doğumun nasıl yönetileceğini okuyun.",
            value: false,
          },
          {
            text: "Doğum sonrası depresyon üzerine araştırma yapın ve belirtileri bilin.",
            value: false,
          },
          {
            text: "Doğum sırasında karşılaşacağınız prosedürler hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Göğüs pompalarını araştırın.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum iznine çıkmadan önce tamamlamanız gereken tüm evrakları doldurun.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Hamilelik size unutturabileceğinden günlük görevlerinizi not edin.",
            value: false,
          },
          {
            text: "Sağlıklı atıştırmalıklar getirin ve masanızda bir şişe su bulundurun.",
            value: false,
          },
          {
            text: "Yakında işe dönmeniz gerekiyorsa ve bir yardımcınız veya bebeğinize bakacak kimse yoksa, günlük bakım seçeneklerini araştırmaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 33,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Her zaman sıcak hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Uyumakta güçlük çekebilirsiniz.",
            value: false,
          },
          {
            text: "Sık sık idrara çıkmanız gerekecek ve bacak krampları ve mide ekşimesi yaşayacaksınız.",
            value: false,
          },
          {
            text: "Sık sık baş ağrısı ve endişe yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Tırnaklarınız kırılgan hale gelebilir.",
            value: false,
          },
          {
            text: "Yatakta pozisyon değiştirirken bağlarınızın esnemesi ve gevşemesi nedeniyle karın bölgesinde ağrı hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Rahminiz ciğerlerinizi iterken nefes darlığı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Daha dikkatsiz ve unutkan olabilirsiniz.",
            value: false,
          },
          {
            text: "Göğüsleriniz kolostrum adı verilen sarımsı bir sıvı sızdırabilir.",
            value: false,
          },
          {
            text: "Braxton Hicks veya yalancı kasılmalar yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Daha beceriksiz olabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Mide ekşimesini önlemek için uyumadan hemen önce yemekten kaçının.",
            value: false,
          },
          {
            text: "Sağlıklı yiyecekler tüketmeye devam edin.",
            value: false,
          },
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Yorucu egzersizden kaçının; yürümek iyidir.",
            value: false,
          },
          {
            text: "Vücut ağrılarını hafifletmek için doğum öncesi yogayı deneyin.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Alışılmadık şekilde üzgün, endişeli veya depresyonda hissediyorsanız, doktorunuza danışın.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Erken doğum risklerini sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Yorgunluğu gidermek için ılık köpük banyosunda kendinizi şımartın.",
            value: false,
          },
          {
            text: "Yatmadan önce en sevdiğiniz rahatlatıcı şarkıları dinleyin.",
            value: false,
          },
          {
            text: "Plasentanızı doğumdan sonra tutmayı planlıyorsanız, bu hafta kapsülleme sürecine kaydolun.",
            value: false,
          },
          {
            text: "Kaşıntılı cildi yatıştırmak için kalamin losyonu deneyin.",
            value: false,
          },
          {
            text: "Bebek partinizin zamanı!",
            value: false,
          },
          {
            text: "Doğum çantanızı hazırlayın.",
            value: false,
          },
          {
            text: "Seçtiğiniz hastaneyi ziyaret edin ve tesislerini görün.",
            value: false,
          },
          {
            text: "Yanınızda uyuyun ve ekstra rahatlık için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Bebek için alışverişe başlayın - bebeğiniz çok hızlı büyüyeceği için çok fazla yeni doğan kıyafet satın almayın.",
            value: false,
          },
          {
            text: "Gün boyunca yeterince dinlenin ve gerekirse kestirin.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuz ile iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Bebeğinizin adına karar verin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Eşinizden bebeğinizle konuşmasını isteyin.",
            value: false,
          },
          {
            text: "Bebeğinizin odasını dekore etmeyi bitirin.",
            value: false,
          },
          {
            text: "Çocuğunuzun geleceği için para biriktirmeye ve yatırım yapmaya başlayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Hamile kadınlar için güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu sürmeyi unutmayın.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hastane Çantanıza Neler Yerleştirmelisiniz",
        checklists: [
          {
            text: "Banyo malzemeleri, terlik ve çoraplar, makyaj ürünleri, diş fırçası, nemlendirici, dudak kremi, deodorant, saç bantları vb. kişisel ekipmanlar",
            value: false,
          },
          {
            text: "Doğum planınız",
            value: false,
          },
          {
            text: "Süt sağmanız gerektiğinde göğüs pompası",
            value: false,
          },
          {
            text: "En az 3 set yenidoğan kıyafeti - Karmaşık kıyafetlerden kaçının, kolları ve bacakları kaplayan pamuklu tulumlar en iyisidir.",
            value: false,
          },
          {
            text: "Rahat yastıklar, en sevdiğiniz şarkılardan oluşan bir çalma listesi, atıştırmalıklar vb. gibi rahatlamanıza yardımcı olacak öğeler",
            value: false,
          },
          {
            text: "Bol, rahat kıyafetler",
            value: false,
          },
          {
            text: "Kimlik kartları, sigorta belgeleri vb. gibi önemli belgeler",
            value: false,
          },
          {
            text: "Telefon ve telefon şarj cihazı",
            value: false,
          },
          {
            text: "Bebek için eve gidiş kıyafeti (çoraplar veya patikler ve battaniyesi dahil)",
            value: false,
          },
          {
            text: "Anne için hijyenik pedler",
            value: false,
          },
          {
            text: "Bebek bezi",
            value: false,
          },
          {
            text: "Islak mendiller, yumuşak bir bebek yıkama ve diğer bebek malzemeleri",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Doğum ve doğum hakkında okumaya devam edin.",
            value: false,
          },
          {
            text: "Doğum sırasında ağrı kesici ve epidural hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Bebek bakımı ve ebeveynlik hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Seçtiğiniz doğum yöntemini okuyun ve hazırlanın.",
            value: false,
          },
          {
            text: "Amniyotik sıvı rüptürü, adet benzeri kramplar, vajinal kanama ve diğerleri gibi doğum eylemi veya erken doğum belirtileri hakkında bilgi edinin.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum iznine çıkmadan önce tamamlamanız gereken tüm evrakları doldurun.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Hamilelik size unutturabileceğinden günlük görevlerinizi not edin.",
            value: false,
          },
          {
            text: "Sağlıklı atıştırmalıklar getirin ve masanızda bir şişe su bulundurun.",
            value: false,
          },
          {
            text: "Yakında işe dönmeniz gerekiyorsa ve bir yardımcınız veya bebeğinize bakacak kimse yoksa, günlük bakım seçeneklerini araştırmaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 34,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Her zamankinden daha yorgun hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Vajinal sıvılarda bir artış fark edebilirsiniz.",
            value: false,
          },
          {
            text: "Baş dönmesi yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Sık sık idrara çıkabilirsiniz.",
            value: false,
          },
          {
            text: "Rahminiz ciğerlerinizi iterken nefessiz hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Göğüslerinizden kolostrum sızdığını fark edebilirsiniz.",
            value: false,
          },
          {
            text: "Ayaklarınız ve ayak bilekleriniz şişebilir.",
            value: false,
          },
          {
            text: "(Geçici) bulanık görme yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Karnınızda veya göğsünüzde pembe, kırmızı, mor, kırmızımsı kahverengi veya koyu kahverengi çizgiler olarak görünebilen çatlaklar olabilir.",
            value: false,
          },
          {
            text: "Şişkinlik ve gaz yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Kabızlık ve hemoroid hastalığınız olabilir.",
            value: false,
          },
          {
            text: "Büyüyen göbeğinizin neden olduğu gerginlik nedeniyle sırt ağrınız olabilir.",
            value: false,
          },
          {
            text: "Uyumakta sorun yaşıyor olabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Mide ekşimesini önlemek için uyumadan hemen önce yemekten kaçının.",
            value: false,
          },
          {
            text: "Sağlıklı yiyecekler tüketmeye devam edin.",
            value: false,
          },
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Yorucu egzersizden kaçının; yürümek iyidir.",
            value: false,
          },
          {
            text: "Vücut ağrılarını hafifletmek için doğum öncesi yogayı deneyin.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Alışılmadık şekilde üzgün, endişeli veya depresyonda hissediyorsanız, doktorunuza danışın.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Plasentanızı doğumdan sonra tutmayı planlıyorsanız, bu hafta kapsülleme sürecine kaydolduğunuzdan emin olun.",
            value: false,
          },
          {
            text: "Kaşıntılı cildi yatıştırmak için kalamin losyonu deneyin.",
            value: false,
          },
          {
            text: "Sırt ağrınız kötü ise karın destek kemeri takın.",
            value: false,
          },
          {
            text: "Doğum çantanızı hazırlayın.",
            value: false,
          },
          {
            text: "Seçtiğiniz hastaneyi ziyaret edin ve tesislerini görün.",
            value: false,
          },
          {
            text: "Yanınızda uyuyun ve ekstra rahatlık için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Bebeğinizin karyolası / beşiği ve araba koltuğu satın alın.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Bebeğinizin adına karar verin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Eşinizden bebeğinizle konuşmasını isteyin.",
            value: false,
          },
          {
            text: "Bebek araba koltuğunuzun doğru şekilde takıldığından emin olun.",
            value: false,
          },
          {
            text: "Çocuğunuzun geleceği için para biriktirmeye ve yatırım yapmaya başlayın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Hamile kadınlar için güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Dışarıda bacak krampları yaşarsanız, oturacak bir yer bulun ve ardından ayak parmaklarınızı vücudunuza doğru esnetin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hastane Çantanıza Neler Yerleştirmelisiniz",
        checklists: [
          {
            text: "Banyo malzemeleri, terlik ve çoraplar, makyaj ürünleri, diş fırçası, nemlendirici, dudak kremi, deodorant, saç bantları vb. kişisel ekipmanlar",
            value: false,
          },
          {
            text: "Doğum planınız",
            value: false,
          },
          {
            text: "Süt sağmanız gerektiğinde göğüs pompası",
            value: false,
          },
          {
            text: "En az 3 set yenidoğan kıyafeti - Karmaşık kıyafetlerden kaçının, kolları ve bacakları kaplayan pamuklu tulumlar en iyisidir.",
            value: false,
          },
          {
            text: "Rahat yastıklar, en sevdiğiniz şarkılardan oluşan bir çalma listesi, atıştırmalıklar vb. gibi rahatlamanıza yardımcı olacak öğeler",
            value: false,
          },
          {
            text: "Bol, rahat kıyafetler",
            value: false,
          },
          {
            text: "Kimlik kartları, sigorta belgeleri vb. gibi önemli belgeler",
            value: false,
          },
          {
            text: "Telefon ve telefon şarj cihazı",
            value: false,
          },
          {
            text: "Bebek için eve gidiş kıyafeti (çoraplar veya patikler ve battaniyesi dahil)",
            value: false,
          },
          {
            text: "Anne için hijyenik pedler",
            value: false,
          },
          {
            text: "Bebek bezi",
            value: false,
          },
          {
            text: "Islak mendiller, yumuşak bir bebek yıkama ve diğer bebek malzemeleri",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Doğum ve doğum hakkında okumaya devam edin.",
            value: false,
          },
          {
            text: "Doğum sırasında ağrı kesici ve epidural hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Bebek bakımı ve ebeveynlik hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Seçtiğiniz doğum yöntemini okuyun ve hazırlanın.",
            value: false,
          },
          {
            text: "Amniyotik sıvı rüptürü, adet benzeri kramplar, vajinal kanama ve diğerleri gibi doğum eylemi veya erken doğum belirtileri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Yenidoğan bebeğinizin doğumdan hemen sonra yaptırması gereken aşılar ve testler hakkında bilgi edinin.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Doğum iznine çıkmadan önce tamamlamanız gereken tüm evrakları doldurun.",
            value: false,
          },
          {
            text: "Siz uzaktayken iş yükünüzü üstlenecek meslektaşınız için notlar hazırlamaya başlayın.",
            value: false,
          },
          {
            text: "Hamilelik size unutturabileceğinden günlük görevlerinizi not edin.",
            value: false,
          },
          {
            text: "Sağlıklı atıştırmalıklar getirin ve masanızda bir şişe su bulundurun.",
            value: false,
          },
          {
            text: "Yakında işe dönmeniz gerekiyorsa ve bir yardımcınız veya bebeğinize bakacak kimse yoksa, günlük bakım seçeneklerini araştırmaya başlayın.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 35,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Göğüsleriniz bebeğinizin alacağı ilk süt olan kolostrum adı verilen sarımsı bir sıvı sızdırabilir.",
            value: false,
          },
          {
            text: "Daha sık mide ekşimesi ve gastrointestinal problemler yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Muhtemelen hafif kasılmalar veya Braxton Hicks kasılmaları hissedeceksiniz.",
            value: false,
          },
          {
            text: "Öksürürken, hapşırırken veya gülerken mesanenizi kontrol etmekte sorun yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Sık sık baş ağrısı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Diş etleriniz kanayabilir.",
            value: false,
          },
          {
            text: "Beceriksiz hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Varisli damarlarınız olabilir.",
            value: false,
          },
          {
            text: "Hemoroid hastası olabilirsiniz.",
            value: false,
          },
          {
            text: "Unutkanlık yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Genişleyen rahim ciğerlerinize baskı uyguladığından nefes almakta zorluk çekebilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Mide ekşimesini önlemek için uyumadan hemen önce yemekten kaçının.",
            value: false,
          },
          {
            text: "Sağlıklı yiyecekler tüketmeye devam edin.",
            value: false,
          },
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Yorucu egzersizden kaçının; yürümek iyidir.",
            value: false,
          },
          {
            text: "Vücut ağrılarını hafifletmek için doğum öncesi yogayı deneyin.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "B Grubu streptococcus tarama testi yaptırın (35.Hafta ile 37.Hafta Arasında)",
            value: false,
          },
          {
            text: "Alışılmadık şekilde üzgün, endişeli veya depresyonda hissediyorsanız, doktorunuza danışın.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Vajinanızdan kanlı akıntı gibi erken doğum belirtilerine dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Bebeğinizin tüm kıyafetlerini yıkayın, katlayın ve yerleştirin.",
            value: false,
          },
          {
            text: "Doğuma başladığınızda ihtiyaç duyabileceğiniz önemli telefon numaralarını not edin.",
            value: false,
          },
          {
            text: "Araba koltuğunu doğru şekilde takma alıştırması yapın.",
            value: false,
          },
          {
            text: "Doğum çantanız hazır olmalıdır.",
            value: false,
          },
          {
            text: "Yanınızda uyuyun ve ekstra rahatlık için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Hamile kadınlar için güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Çocuğunuzu şarkılar söyleyerek ve hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Dışarıda ve dışarıda bacak krampları yaşarsanız, oturacak bir yer bulun ve ardından ayak parmaklarınızı vücudunuza doğru esnetin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hastane Çantanıza Neler Yerleştirmelisiniz",
        checklists: [
          {
            text: "Banyo malzemeleri, terlik ve çoraplar, makyaj ürünleri, diş fırçası, nemlendirici, dudak kremi, deodorant, saç bantları vb. kişisel ekipmanlar",
            value: false,
          },
          {
            text: "Doğum planınız",
            value: false,
          },
          {
            text: "Süt sağmanız gerektiğinde göğüs pompası",
            value: false,
          },
          {
            text: "En az 3 set yenidoğan kıyafeti - Karmaşık kıyafetlerden kaçının, kolları ve bacakları kaplayan pamuklu tulumlar en iyisidir.",
            value: false,
          },
          {
            text: "Rahat yastıklar, en sevdiğiniz şarkılardan oluşan bir çalma listesi, atıştırmalıklar vb. gibi rahatlamanıza yardımcı olacak öğeler",
            value: false,
          },
          {
            text: "Bol, rahat kıyafetler",
            value: false,
          },
          {
            text: "Kimlik kartları, sigorta belgeleri vb. gibi önemli belgeler",
            value: false,
          },
          {
            text: "Telefon ve telefon şarj cihazı",
            value: false,
          },
          {
            text: "Bebek için eve gidiş kıyafeti (çoraplar veya patikler ve battaniyesi dahil)",
            value: false,
          },
          {
            text: "Anne için hijyenik pedler",
            value: false,
          },
          {
            text: "Bebek bezi",
            value: false,
          },
          {
            text: "Islak mendiller, yumuşak bir bebek yıkama ve diğer bebek malzemeleri",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Normal veya sezaryen doğum sırasında karşılaşacağınız prosedürler hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "İsterseniz bir doğum fotoğrafçısı ayarlayın.",
            value: false,
          },
          {
            text: "Yapay ağrı kesici istemiyorsanız, doğum sırasında nefes alma tekniklerini okuyun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı yırtılması, adet benzeri kramplar, vajinal kanama ve diğerleri gibi doğum eylemi veya erken doğum belirtileri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Yenidoğan bebeğinizin doğumdan hemen sonra yaptırması gereken aşılar ve testler hakkında bilgi edinin.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşe döndüğünüzde bebeğinize kimin bakacağına dair planlar yapın.",
            value: false,
          },
          {
            text: "İş yerinde uzun saatler oturmanız gerekiyorsa, sandalyeniz yerine kısa süreli egzersiz topunun üzerinde oturmayı deneyin.",
            value: false,
          },
          {
            text: "Doğum iznine çıkmadan önce tamamlamanız gereken tüm evrakları doldurun.",
            value: false,
          },
          {
            text: "Hamilelik size unutturabileceğinden günlük görevlerinizi not edin.",
            value: false,
          },
          {
            text: "İşteyken yeterince su içtiğinizden emin olun.",
            value: false,
          },
          {
            text: "Ofisinizde emzirme / süt sağma odası var mı? Değilse, bir tane organize etme konusunda yöneticinizle konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 36,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: 'Evinizi ve bebeğinizin odasını toparlama ve düzenleme dürtüsü olan "yuva yapmaya" başlayabilirsiniz.',
            value: false,
          },
          {
            text: "Sırt ağrınız daha da kötüleşebilir.",
            value: false,
          },
          {
            text: "Vajinal akıntınız yoğun olacaktır.",
            value: false,
          },
          {
            text: "Bebeğiniz muhtemelen şu ana kadar döndüğü için karnınızın alt kısmı daha ağır hissedecektir.",
            value: false,
          },
          {
            text: "Yürümek zor olabilir, pelvik ağrı hissedersiniz.",
            value: false,
          },
          {
            text: "Braxton Hicks kasılmalarını daha sık hissedeceksiniz.",
            value: false,
          },
          {
            text: "Şişkinlik ve gaz yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Banyoya sık sık gitmeniz gerekecek.",
            value: false,
          },
          {
            text: "Ayaklarınız ve ayak bilekleriniz şişebilir.",
            value: false,
          },
          {
            text: "Mide ekşimesi ve hazımsızlık çekebilirsiniz.",
            value: false,
          },
          {
            text: "Göğüsleriniz kolostrum adı verilen sarımsı bir sıvı sızdırabilir.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Mide ekşimesini önlemek için uyumadan hemen önce yemekten kaçının.",
            value: false,
          },
          {
            text: "Sağlıklı yiyecekler tüketmeye devam edin.",
            value: false,
          },
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Yorucu egzersizden kaçının; yürümek iyidir.",
            value: false,
          },
          {
            text: "Vücut ağrılarını hafifletmek için doğum öncesi yogayı deneyin.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "B Grubu streptococcus tarama testi yaptırın (35.Hafta ile 37.Hafta Arasında)",
            value: false,
          },
          {
            text: "Alışılmadık şekilde üzgün, endişeli veya depresyonda hissediyorsanız, doktorunuza danışın.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Vajinanızdan kanlı akıntı gibi erken doğum belirtilerine dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Hamileliğin bu aşamasında uçakla seyahat önerilmez.",
            value: false,
          },
          {
            text: "Ilık bir banyo pelvik ağrıyı hafifletmeye yardımcı olur.",
            value: false,
          },
          {
            text: "Doğum çantanız hazır olmalıdır.",
            value: false,
          },
          {
            text: "Yanınızda uyuyun ve ekstra rahatlık için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Ağır eşyaları kaldırmaktan kaçının.",
            value: false,
          },
          {
            text: "Güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Hamile kadınlar için güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Çocuğunuzu şarkılar söyleyerek ve hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Dışarıda ve dışarıda bacak krampları yaşarsanız, oturacak bir yer bulun ve ardından ayak parmaklarınızı vücudunuza doğru esnetin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hastane Çantanıza Neler Yerleştirmelisiniz",
        checklists: [
          {
            text: "Banyo malzemeleri, terlik ve çoraplar, makyaj ürünleri, diş fırçası, nemlendirici, dudak kremi, deodorant, saç bantları vb. kişisel ekipmanlar",
            value: false,
          },
          {
            text: "Doğum planınız",
            value: false,
          },
          {
            text: "Süt sağmanız gerektiğinde göğüs pompası",
            value: false,
          },
          {
            text: "En az 3 set yenidoğan kıyafeti - Karmaşık kıyafetlerden kaçının, kolları ve bacakları kaplayan pamuklu tulumlar en iyisidir.",
            value: false,
          },
          {
            text: "Rahat yastıklar, en sevdiğiniz şarkılardan oluşan bir çalma listesi, atıştırmalıklar vb. gibi rahatlamanıza yardımcı olacak öğeler",
            value: false,
          },
          {
            text: "Bol, rahat kıyafetler",
            value: false,
          },
          {
            text: "Kimlik kartları, sigorta belgeleri vb. gibi önemli belgeler",
            value: false,
          },
          {
            text: "Telefon ve telefon şarj cihazı",
            value: false,
          },
          {
            text: "Bebek için eve gidiş kıyafeti (çoraplar veya patikler ve battaniyesi dahil)",
            value: false,
          },
          {
            text: "Anne için hijyenik pedler",
            value: false,
          },
          {
            text: "Bebek bezi",
            value: false,
          },
          {
            text: "Islak mendiller, yumuşak bir bebek yıkama ve diğer bebek malzemeleri",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Normal veya C-kesitli doğum sırasında karşılaşacağınız prosedürler hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "İsterseniz bir doğum fotoğrafçısı ayarlayın.",
            value: false,
          },
          {
            text: "Yapay ağrı kesici istemiyorsanız, doğum sırasında nefes alma tekniklerini okuyun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı yırtılması, adet benzeri kramplar, vajinal kanama ve diğerleri gibi doğum eylemi veya erken doğum belirtileri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Yenidoğan bebeğinizin doğumdan hemen sonra yaptırması gereken aşılar ve testler hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Yeni doğmuş bebeğiniz için göbek kordonu bakımı hakkında bilgi edinin.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "İşe döndüğünüzde bebeğinize kimin bakacağına dair planlar yapın.",
            value: false,
          },
          {
            text: "İş yerinde uzun saatler oturmanız gerekiyorsa, sandalyeniz yerine kısa süreli egzersiz topunun üzerinde oturmayı deneyin.",
            value: false,
          },
          {
            text: "Doğum iznine çıkmadan önce tamamlamanız gereken tüm evrakları doldurun.",
            value: false,
          },
          {
            text: "Hamilelik size unutturabileceğinden günlük görevlerinizi not edin.",
            value: false,
          },
          {
            text: "İşteyken yeterince su içtiğinizden emin olun.",
            value: false,
          },
          {
            text: "Ofisinizde emzirme / süt sağma odası var mı? Değilse, bir tane organize etme konusunda yöneticinizle konuşun.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 37,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Özellikle geceleri bacak krampları yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Yoğun ve canlı gibi rüyalarınız olabilir.",
            value: false,
          },
          {
            text: 'Vajinal akıntınız artacaktır ("kanlı şov(nişan)" veya kanlı akıntıya karşı dikkatli olun)',
            value: false,
          },
          {
            text: "Bebeğiniz eskisi kadar tekmelemeyecek ama yine de hareketleri hissedeceksiniz.",
            value: false,
          },
          {
            text: "Mide ekşimesi ve hazımsızlık çekebilirsiniz.",
            value: false,
          },
          {
            text: "Çatlaklar artabilir.",
            value: false,
          },
          {
            text: "Unutkan hissedebilirsiniz.",
            value: false,
          },
          {
            text: "Emzirmeye hazırlanırken meme uçlarınızın şimdi patladığını fark edebilirsiniz.",
            value: false,
          },
          {
            text: "Pelvik ağrı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Varisli damarlarınız olabilir.",
            value: false,
          },
          {
            text: "Bulantı çekebilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Mide ekşimesini önlemek için uyumadan hemen önce yemekten kaçının.",
            value: false,
          },
          {
            text: "Sağlıklı yiyecekler tüketmeye devam edin.",
            value: false,
          },
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Yorucu egzersizden kaçının; yürümek iyidir.",
            value: false,
          },
          {
            text: "Vücut ağrılarını hafifletmek için doğum öncesi yogayı deneyin.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "B Grubu streptococcus tarama testi yaptırın (35.Hafta ile 37.Hafta Arasında)",
            value: false,
          },
          {
            text: "Alışılmadık şekilde üzgün, endişeli veya depresyonda hissediyorsanız, doktorunuza danışın.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Vajinanızdan kanlı akıntı gibi erken doğum belirtilerine dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Doğum sırasında yırtılmayı en aza indirmek için perineal masajı deneyin.",
            value: false,
          },
          {
            text: "Seçtiğiniz doğum hastanesine erkenden kaydolun, böylece check-in deneyiminiz daha sonra daha kolay olur.",
            value: false,
          },
          {
            text: "Bebeğinizin odasının bittiğinden emin olun.",
            value: false,
          },
          {
            text: "Doğuma başladığınızda ihtiyaç duyabileceğiniz önemli telefon numaralarını not edin.",
            value: false,
          },
          {
            text: "Araba koltuğunu doğru şekilde takabildiğinizden emin olun.",
            value: false,
          },
          {
            text: "Doğum çantanız hazır olmalıdır.",
            value: false,
          },
          {
            text: "Yan tarafınızda uyuyun ve ekstra rahatlık için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Doğum fotoğrafçınız varsa, randevu alın.",
            value: false,
          },
          {
            text: "Hamile kadınlar için güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Çocuğunuzu şarkılar söyleyerek ve hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Dışarıda bacak krampları yaşarsanız, oturacak bir yer bulun ve ardından ayak parmaklarınızı vücudunuza doğru esnetin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Normal veya sezaryen doğum sırasında karşılaşacağınız prosedürler hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Yapay ağrı kesici istemiyorsanız, doğum sırasında nefes alma tekniklerini okuyun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı rüptürü, adet benzeri kramplar, vajinal kanama ve diğer gibi doğum eylemi veya erken doğum belirtileri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Perine masajı hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Yeni doğmuş bebeğiniz için göbek kordonu bakımı hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Yeni doğmuş bebeğinizi nasıl yıkayacağınızı ve çocuk bezini nasıl değiştireceğinizi öğrenin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Çalışan Bir Anneyseniz",
        checklists: [
          {
            text: "Neredeyse izne çıkma zamanı - bu hafta veya sonraki hafta izninize bile başlayabilirsiniz.",
            value: false,
          },
          {
            text: "İş yerinde uzun saatler oturmanız gerekiyorsa, sandalyeniz yerine kısa süreli egzersiz topunun üzerinde oturmayı deneyin.",
            value: false,
          },
          {
            text: "Siz izindeyken sizin için ilgilenecek olan meslektaşınıza görevleri devredin.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
          {
            text: "Vajinanızdan sıra dışı bir sıvı sızdığını gözlemliyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 38,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Şimdi daha fazla vajinal akıntınız olabilir ve hatta mukus tıkacının (nişan) açılma sürecini bile geçebilirsiniz.",
            value: false,
          },
          {
            text: "Karnınız büyük ve alçaktır ve ayak bileklerinizde ve hatta parmaklarınızda şişlik yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Göğüsleriniz süt üretiminin başladığını belirten sarımsı sıvı kolostrum damlatmaya başlayacaktır.",
            value: false,
          },
          {
            text: "Bebeğiniz doğuma hazırlanırken pelvisinizin altına inerken bacaklarınız ve pelvik bölgeniz ağrır.",
            value: false,
          },
          {
            text: "Bazı kadınlar bu zamanlarda ishal yaşarlar.",
            value: false,
          },
          {
            text: "Daha fazla Braxton Hicks kasılması hissediyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Karnınız tüm bu esnemeden dolayı kaşınıyor.",
            value: false,
          },
          {
            text: "Banyoya sık sık gitmeniz gerekecek.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Mide ekşimesini önlemek için uyumadan hemen önce yemekten kaçının.",
            value: false,
          },
          {
            text: "Sağlıklı yiyecekler tüketmeye devam edin.",
            value: false,
          },
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Yorucu egzersizden kaçının; yürümek iyidir.",
            value: false,
          },
          {
            text: "Vücut ağrılarını hafifletmek için doğum öncesi yogayı deneyin.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Alışılmadık şekilde üzgün, endişeli veya depresyonda hissediyorsanız, doktorunuza danışın.",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Vajinanızdan kanlı akıntı gibi erken doğum belirtilerine dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Göğüsleriniz kolostrum damlamaya başlarsa, giysilerinizi korumak için sütyeninize emzirme pedleri yerleştirin.",
            value: false,
          },
          {
            text: "Doğum ve yenidoğan listelerinizi iki kez kontrol edin.",
            value: false,
          },
          {
            text: "Sık sık süt sağmayı planlıyorsanız bir anne sütü pompası satın alın.",
            value: false,
          },
          {
            text: "Göğüs pedleri ve emzirme sütyenleri almayı unutmayın.",
            value: false,
          },
          {
            text: "Doğuma başladığınızda ihtiyaç duyabileceğiniz önemli telefon numaralarını not edin.",
            value: false,
          },
          {
            text: "Bebek koltuğunuzun doğru şekilde takıldığından emin olun.",
            value: false,
          },
          {
            text: "En sevdiğiniz yemeklerden bazılarını pişmiş, porsiyonlanmış ve dondurulmuş olarak alın.",
            value: false,
          },
          {
            text: "Doğum çantanız hazır olmalıdır.",
            value: false,
          },
          {
            text: "Yan tarafınız üzerinde uyuyun ve ekstra rahatlık için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Dışarı çıkarken yanınızda sağlıklı bir atıştırmalık ve küçük bir şişe su taşıyın.",
            value: false,
          },
          {
            text: "Doğum fotoğrafçınız varsa, randevu alın.",
            value: false,
          },
          {
            text: "Hamile kadınlar için güvenli olan kozmetik ürünleri seçin.",
            value: false,
          },
          {
            text: "Çatlakları önlemek için karnınıza ve diğer bölgelere nemlendirici bir vücut losyonu uygulayın.",
            value: false,
          },
          {
            text: "Çocuğunuzu şarkılar söyleyerek ve hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Dışarıda bacak krampları yaşarsanız, oturacak bir yer bulun ve ardından ayak parmaklarınızı vücudunuza doğru esnetin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Normal veya sezaryen doğum sırasında karşılaşacağınız prosedürler hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Doğum indüksiyonu (suni sancı) hakkında araştırma yapın.",
            value: false,
          },
          {
            text: "Yapay ağrı kesici istemiyorsanız, doğum sırasında nefes alma tekniklerini okuyun.",
            value: false,
          },
          {
            text: "Bebek bakımı ve ebeveynlik hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "En az 45 saniye süren ve 5 dakikaya kadar görünen kasılmaları araştırın.",
            value: false,
          },
          {
            text: "Ameliyatla doğum yapmak istiyorsanız sezaryen izlerini nasıl tedavi edeceğinizi öğrenin.",
            value: false,
          },
          {
            text: "Gecikmiş doğum için riskleri bilin.",
            value: false,
          },
          {
            text: "Doğumu hızlandırmanın doğal yollarını bilin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
          {
            text: "Vajinanızdan sıra dışı bir sıvı sızdığını gözlemliyorsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 39,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Daha fazla Braxton Hicks kasılması hissediyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Şimdi daha fazla vajinal akıntınız olabilir ve nişan gelmiş olabilir.",
            value: false,
          },
          {
            text: "Her zaman yerinizi temizleme dürtüsüne sahipsiniz (yuvalama). Ama kendinizi çok fazla zorlamayın!",
            value: false,
          },
          {
            text: "Suyunuz gelebilir - amniyotik keseniz yırtılır ve sıvınız dışarı fışkırır.",
            value: false,
          },
          {
            text: "Pelvisiniz, mesaneniz ve kalçalarınız üzerinde artan baskı hissedebilir ve pelvik ve / veya sırt ağrısı yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Bazı kadınlar bu zamanlarda ishal yaşarlar.",
            value: false,
          },
          {
            text: "Şiddetli mide ekşimesi yaşayabilirsiniz.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Mide ekşimesini önlemek için uyumadan hemen önce yemekten kaçının.",
            value: false,
          },
          {
            text: "Sağlıklı yiyecekler tüketmeye devam edin.",
            value: false,
          },
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Hareket etmek ne kadar zor olsa da, her gün en azından kısa bir yürüyüşe çıkmaya çalışın.",
            value: false,
          },
          {
            text: "Doğumu başlatmaya yardımcı olabileceğinden, merdivenlerden dikkatlice yukarı ve aşağı inip çıkın.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Bebeğinizin gelişimini, pozisyonunu kontrol etmek ve fetal kalp atışını kaydetmek için bir ultrason alın.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Vajinanızdan kanlı akıntı gibi erken doğum belirtilerine dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Doktorunuza doğum eylemini teşvik etmeyi/tetiklemeyi sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Doğum çantanızın hazır olduğundan emin olun.",
            value: false,
          },
          {
            text: "Eşinizle, sizi doğum sancıları sırasında nasıl desteklemesini istediğiniz hakkında konuşun.",
            value: false,
          },
          {
            text: "Doğuma başladığınızda ihtiyaç duyabileceğiniz önemli telefon numaralarını not edin.",
            value: false,
          },
          {
            text: "Bebek araba koltuğunuzun doğru şekilde takıldığından emin olun.",
            value: false,
          },
          {
            text: "Cinsel ilişki doğumu başlatmaya yardımcı olabilir.",
            value: false,
          },
          {
            text: "Çocuk odasının bebeğin eve gelişine hazır olduğundan emin olun.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Vakum ve forseps gibi doğum prosedürlerinin artılarını ve eksilerini öğrenin.",
            value: false,
          },
          {
            text: "Kolostrumun önemi hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Doğumdan sonra ten tene temasın önemini araştırın.",
            value: false,
          },
          {
            text: "Doğum sırasında nasıl nefes alacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Yenidoğan bakımı hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Amniyotik sıvı rüptürü, adet benzeri kramplar gibi doğum eylemi veya erken doğum belirtileri hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Sezaryen doğum durumunda, sezaryen izlerinin bakımı hakkında daha fazla bilgi edinin.",
            value: false,
          },
          {
            text: "Doğumu hızlandırmanın doğal yollarını bilin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
          {
            text: "Vajinanızdan sıra dışı bir sıvı sızdığını gözlemliyorsanız",
            value: false,
          },
          {
            text: "En az 45 saniye süren ve 5 dakika arayla gelen kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 40,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Pelvik bölgenizde baskı ve ağrı hissedeceksiniz.",
            value: false,
          },
          {
            text: "Çok yorgun hissedebilirsiniz ve uyumak zor olabilir.",
            value: false,
          },
          {
            text: "Daha fazla Braxton Hicks kasılması hissediyor olabilirsiniz.",
            value: false,
          },
          {
            text: "Suyunuz gelebilir - amniyotik keseniz yırtılır ve sıvınız dışarı fışkırır.",
            value: false,
          },
          {
            text: "Bazı kadınlar bu zamanlarda ishal yaşarlar.",
            value: false,
          },
          {
            text: "Bacak krampları yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Yerini her zaman temizleme dürtüsüne sahipsin (yuvalama).",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Hareket etmek ne kadar zor olsa da, her gün en azından kısa bir yürüyüşe çıkmaya çalışın.",
            value: false,
          },
          {
            text: "Doğumu başlatmaya yardımcı olabileceğinden, merdivenlerden dikkatlice yukarı ve aşağı inip çıkın.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Bebeğinizin pozisyonunu kontrol etmek ve açılmaya başlayıp başlamadığınızı görmek için pelvik muayene olun.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Fetal kalp atış hızını kontrol edin.",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Vajinanızdan kanlı akıntı gibi erken doğum belirtilerine dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Doktorunuza doğum eylemini teşvik etmeyi/tetiklemeyi sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Mümkün olduğu kadar uyuyun ve dinlenin - enerjiye ihtiyacınız olacak.",
            value: false,
          },
          {
            text: "Doğum belirtileri varsa hemen doktorunuzu arayın.",
            value: false,
          },
          {
            text: "Doğum çantanızın hazır olduğundan emin olun.",
            value: false,
          },
          {
            text: "Eşinizle, sizi doğum sancıları sırasında nasıl desteklemesini istediğiniz hakkında konuşun.",
            value: false,
          },
          {
            text: "Doğum sırasında ağrıyı nasıl azaltacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Doğuma başladığınızda ihtiyaç duyabileceğiniz önemli telefon numaralarını not edin.",
            value: false,
          },
          {
            text: "Cinsel ilişki doğumu başlatabilir.",
            value: false,
          },
          {
            text: "Yanınızda uyuyun ve ekstra rahatlık için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Çocuk odasının bebeğin eve gelişine hazır olduğundan emin olun.",
            value: false,
          },
          {
            text: "Kasılmalar 45 ila 60 saniye sürdüğünde ve üç ila beş dakika arayla olduğunda hastaneye gidin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Normal doğum yapmak istiyorsanız, doğum sırasında nefesinizi nasıl düzgün bir şekilde yöneteceğinizi öğrenin.",
            value: false,
          },
          {
            text: "Bebeğinizi göğsünüze nasıl tutacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Bebek bakımı ve ebeveynlik hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Nasıl doğum yapacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Eşinizin doğum yaptıktan sonra sizi nasıl destekleyebileceğini okuyun.",
            value: false,
          },
          {
            text: "Su kesesinin yırtılmasının belirtilerini bilin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
          {
            text: "Vajinanızdan sıra dışı bir sıvı sızdığını gözlemliyorsanız",
            value: false,
          },
          {
            text: "En az 45 saniye süren ve 5 dakika arayla gelen kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 41,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Pelvik bölgenizde baskı ve ağrı hissedeceksiniz.",
            value: false,
          },
          {
            text: "Vajinanızdan çıkan kanlı mukus görebilirsiniz; bu mukus tıkacınızın çıktığının bir işaretidir.",
            value: false,
          },
          {
            text: "Suyunuz gelebilir - amniyotik keseniz yırtılır ve sıvınız dışarı fışkırır.",
            value: false,
          },
          {
            text: "Kasılmalar yaşamaya başlayabilirsiniz - gerçek kasılmalar zamanla güçlenir ve sıklaşır.",
            value: false,
          },
          {
            text: "Bazı kadınlar bu zamanlarda ishal yaşarlar.",
            value: false,
          },
          {
            text: "Bacak krampları yaşayabilirsiniz.",
            value: false,
          },
          {
            text: "Yerini her zaman temizleme dürtüsüne sahipsin (yuvalama).",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Hareket etmek ne kadar zor olsa da, her gün en azından kısa bir yürüyüşe çıkmaya çalışın.",
            value: false,
          },
          {
            text: "Doğumu başlatmaya yardımcı olabileceğinden, merdivenlerden dikkatlice yukarı ve aşağı inip çıkın.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Bebeğinizin pozisyonunu kontrol etmek ve açılmanın başlayıp başlamadığını görmek için pelvik muayene olun.",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Vajinanızdan kanlı akıntı gibi erken doğum belirtilerine dikkat edin.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Doktorunuza doğum eylemini teşvik etmeyi/tetiklemeyi sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Mümkün olduğu kadar uyuyun ve dinlenin - enerjiye ihtiyacınız olacak.",
            value: false,
          },
          {
            text: "Ilık bir banyo yaparak veya yüzerek rahatlamaya çalışın.",
            value: false,
          },
          {
            text: "Doğum belirtileri varsa hemen doktorunuzu arayın.",
            value: false,
          },
          {
            text: "Doğum çantanızın hazır olduğundan emin olun.",
            value: false,
          },
          {
            text: "Eşinizle, sizi doğum sancıları sırasında nasıl desteklemesini istediğiniz hakkında konuşun.",
            value: false,
          },
          {
            text: "Doğum sırasında ağrıyı nasıl azaltacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Doğuma başladığınızda ihtiyaç duyabileceğiniz önemli telefon numaralarını not edin.",
            value: false,
          },
          {
            text: "Cinsel ilişki doğumu başlatabilir.",
            value: false,
          },
          {
            text: "Yanınızda uyuyun ve ekstra rahatlık için hamilelik yastığı kullanın.",
            value: false,
          },
          {
            text: "Bebeğinizin hareketlerini takip edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi günün daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzla iletişime geçin.",
            value: false,
          },
          {
            text: "Karnınızın haftalık bir resmini çekin.",
            value: false,
          },
          {
            text: "Çocuk odasının bebeğin eve gelişine hazır olduğundan emin olun.",
            value: false,
          },
          {
            text: "Kasılmalar 45 ila 60 saniye sürdüğünde ve üç ila beş dakika arayla olduğunda hastaneye gidin.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Normal doğum yapmak istiyorsanız, doğum sırasında nefesinizi nasıl düzgün bir şekilde yöneteceğinizi öğrenin.",
            value: false,
          },
          {
            text: "Bebeğinizi göğsünüze nasıl tutacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Bebek bakımı ve ebeveynlik hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Nasıl doğum yapacağınızı öğrenin.",
            value: false,
          },
          {
            text: "Eşinizin doğum yaptıktan sonra sizi nasıl destekleyebileceğini okuyun.",
            value: false,
          },
          {
            text: "Su kesesinin yırtılmasının belirtilerini bilin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
          {
            text: "Vajinanızdan sıra dışı bir sıvı sızdığını gözlemliyorsanız",
            value: false,
          },
          {
            text: "En az 45 saniye süren ve 5 dakika arayla gelen kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 42,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Düzenli kasılmalar yaşayabilirsiniz - gerçek doğum kasılmaları tekrar tekrar, daha kısa aralıklarla ve daha yüksek yoğunlukta olacaktır.",
            value: false,
          },
          {
            text: "Bazen kanla karışan kalın mukus akıntısı yaşayabilirsiniz - bu, serviksin doğuma hazırlandığının bir işaretidir.",
            value: false,
          },
          {
            text: "Berrak, kokusuz bir sıvı fışkırması veya hatta sürekli bir damlama hissedebilirsiniz. Amniyotik kesenizin muhtemelen patladığını gösterir.",
            value: false,
          },
          {
            text: "Bacak krampları, sık idrara çıkma, pelvik ve sırt ağrıları, yuva içgüdüleri, lekelenme, hemoroid ve ishal yaşayabilirsiniz",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Beslenme ve Sağlık",
        checklists: [
          {
            text: "Her gün en az 10-12 bardak su için.",
            value: false,
          },
          {
            text: "Gazlı içecek içmekten kaçının.",
            value: false,
          },
          {
            text: "Daha fazla sebze, meyve ve diğer sağlıklı yiyeceklerle dengeli bir diyet yapın.",
            value: false,
          },
          {
            text: "Çok fazla tuz, şeker, MSG ve korunmuş gıdalardan kaçının.",
            value: false,
          },
          {
            text: "Hamilelik sırasında çiğ veya yarı pişmiş yiyecekler tüketmekten kaçının.",
            value: false,
          },
          {
            text: "Doğum öncesi vitaminlerinizi günlük alın.",
            value: false,
          },
          {
            text: "Size enerji vermek ve yorgunlukla mücadele etmek için protein ve karbonhidrat bakımından zengin atıştırmalıklar yiyin.",
            value: false,
          },
          {
            text: "Kafein alımınızı sınırlayın.",
            value: false,
          },
          {
            text: "Hareket etmek ne kadar zor olsa da, her gün en azından kısa bir yürüyüşe çıkmaya çalışın.",
            value: false,
          },
          {
            text: "Doğumu başlatmaya yardımcı olabileceğinden, merdivenlerden dikkatlice yukarı ve aşağı inip çıkın.",
            value: false,
          },
          {
            text: "Pelvik kaslarınızı doğum için güçlendirecek Kegel egzersizlerini uygulayın.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Sağlık Kontrolleri",
        checklists: [
          {
            text: "Kilo alımınızı izleyin (Bu, hamilelik öncesi kilonuza ve boyunuza bağlıdır. Genel olarak, hamilelikte ortalama toplam kilo artışı 9 ile 14 kg arasındadır).",
            value: false,
          },
          {
            text: "Kan basıncınızı ve kan şekeri seviyenizi kontrol edin.",
            value: false,
          },
          {
            text: "Bebeğinizin pozisyonunu kontrol etmek ve açılmaya başlayıp başlamadığınızı görmek için pelvik muayene olun.",
            value: false,
          },
          {
            text: "İdrar testi - protein, glikoz (şeker), beyaz kan hücreleri, kan ve bakterileri kontrol etmek için",
            value: false,
          },
          {
            text: "Fetal kalp atış hızını kontrol edin.",
            value: false,
          },
          {
            text: "Ellerinizin veya ayaklarınızın şiş olup olmadığını kontrol edin.",
            value: false,
          },
          {
            text: "Doktor, fetal bebeğinizin kalp atış hızını, tepkisini ve iyiliğini değerlendirmek için ultrason, nst ve biyofiziksel profil önerebilir.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuza Sormanız Gereken Sorular",
        checklists: [
          {
            text: "Preeklampsi ve gestasyonel diyabet riski olup olmadığını sorun.",
            value: false,
          },
          {
            text: "Şiddetli miyopiniz varsa vajinal doğum yapmanın risklerini sorun.",
            value: false,
          },
          {
            text: "Doktorunuza bebeğin pozisyonunu sorun.",
            value: false,
          },
          {
            text: "Amniyotik sıvı seviyelerinizi sorun.",
            value: false,
          },
          {
            text: "Doktorunuza plasental pozisyonu sorun.",
            value: false,
          },
          {
            text: "Doktorunuza doğum eylemini teşvik etmeyi/tetiklemeyi sorun.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Hatırlatmalar",
        checklists: [
          {
            text: "Her an gelebilecek doğum belirtilerini izlemeye devam edin.",
            value: false,
          },
          {
            text: "Bebeğin durumu zayıf veya yüksek riskli ise doktorunuz indüksiyon (suni sancı) veya sezaryen önerebilir.",
            value: false,
          },
          {
            text: "Doğuma hazırlık olarak vücudunuzu mümkün olduğunca dinlendirmek için zaman ayırın.",
            value: false,
          },
          {
            text: "Doğuma başladığınızda ihtiyaç duyabileceğiniz önemli telefon numaralarını not edin.",
            value: false,
          },
          {
            text: "Amniyotik kesenin yırtıldığına dair belirtileri tanımayı öğrenin.",
            value: false,
          },
          {
            text: "Doğum belirtileri varsa hemen doktorunuzu arayın.",
            value: false,
          },
          {
            text: "Doğum çantanızın ihtiyacınız olan her şeyi içerdiğinden ve gitmeye hazır olduğunuzdan emin olun.",
            value: false,
          },
          {
            text: "Doğumunuza hazırlanmak için neyin gerekli olduğu konusunda kocanıza bilgi verin.",
            value: false,
          },
          {
            text: "Doğum sırasında ağrıyı azaltmak için egzersizler yapın.",
            value: false,
          },
          {
            text: "Sevdiğiniz şeyleri yaparak zihninizin dikkatini dağıtarak kendinizi sakinleştirin.",
            value: false,
          },
          {
            text: "Yapabileceğin son hamile özçekimini yap!",
            value: false,
          },
          {
            text: "Çocuk odasının bebeğin eve gelişine hazır olduğundan emin olun.",
            value: false,
          },
          {
            text: "Eşinizden bebeğinizle konuşmasını isteyin.",
            value: false,
          },
          {
            text: "Bu aşamada cinsel ilişki çok rahatsız edici olabilir, ancak doğumu tetikleyebilir.",
            value: false,
          },
          {
            text: "Küçük çocuğunuzu şarkılar söyleyerek veya hatta bebeğinizle konuşarak canlandırmak için günde en az 10-15 dakika harcayın.",
            value: false,
          },
          {
            text: "Günde iki kez - sabah ve akşam olmak üzere - fetal hareketleri kontrol edin.",
            value: false,
          },
          {
            text: "Yemekten sonra olduğu gibi bebeğin daha aktif olduğu bir zaman seçin. İki saat içinde en az 10 bebek hareketi hissetmezseniz, doktorunuzu arayın.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Hamilelik Araştırması",
        checklists: [
          {
            text: "Doğum sırasında nefesinizi nasıl düzgün bir şekilde yöneteceğinizi bilmek önemlidir.",
            value: false,
          },
          {
            text: "Bebek bakımı ve ebeveynlik hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Amniyotik sıvı rüptürü, adet kanaması (kramplar, vajinal kanama ve diğerleri gibi) gibi doğum belirtilerini öğrenin.",
            value: false,
          },
          {
            text: "Geç doğum ve doğum indüksiyonu hakkında bilgi edinin.",
            value: false,
          },
          {
            text: "Sezaryen doğum durumunda, sezaryen izlerinin bakımı hakkında daha fazla bilgi edinin.",
            value: false,
          },
          {
            text: "Doğumu hızlandırmanın doğal yollarını bilin.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Doktorunuzu Arayın",
        checklists: [
          {
            text: "38 °C’den yüksek ateşiniz varsa",
            value: false,
          },
          {
            text: "Aşırı veya kokulu vajinal akıntı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli kusma ve devam eden mide bulantısı yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli veya sürekli karın ağrısı hissediyorsanız",
            value: false,
          },
          {
            text: "İdrar yaparken ağrı hissediyorsanız",
            value: false,
          },
          {
            text: "Elleriniz ve ayaklarınız ciddi şekilde şişmişse",
            value: false,
          },
          {
            text: "Lekelenme veya vajinal kanama yaşıyorsanız",
            value: false,
          },
          {
            text: "Şiddetli baş ağrısı çekiyorsanız",
            value: false,
          },
          {
            text: "Görme bozukluğu yaşarsanız",
            value: false,
          },
          {
            text: "Yüzünüz aniden şişmiş görünüyorsa (bu bir preeklampsi belirtisi olabilir)",
            value: false,
          },
          {
            text: "Fetal harekette keskin bir düşüş varsa",
            value: false,
          },
          {
            text: "Güçlü, ağrılı veya düzenli kasılmalar yaşarsanız",
            value: false,
          },
          {
            text: "Vajinanızdan sıra dışı bir sıvı sızdığını gözlemliyorsanız",
            value: false,
          },
          {
            text: "En az 45 saniye süren ve 5 dakika arayla gelen kasılmalar yaşarsanız",
            value: false,
          },
        ],
      },
    ],
  },
];

export { default_pregnancy_milestone_value };
